<template>
  <div id="profileDocuments" :style="cssVars">
    <v-layout v-if="!currentDocument" wrap class="pf-box-shadow border-radius-5 pa-2">
      <v-flex sm9 class="flex-start">
        <v-btn fab :to="{ path: '/request/profileDocs' }" class="pf-btn-fab-sm">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <span class="font-weight-black pf-font-20">Custom Profile Book - Content</span>
      </v-flex>
      <v-layout sm3 wrap class="flex-end">
        <!-- <v-flex xs3 class="flex-row">
          <v-icon class="mr-1 pf-text-teal" size="26">
            volume_up
          </v-icon>
          <span class="pf-text-teal pf-font-14">Help</span>
        </v-flex> -->
        <v-flex xs12 class="flex-row">
          <v-avatar size="40px" :style="{ background: `url(${ clientAvatar }) 50% 50% / cover no-repeat`, border: 'solid 4px #fff', imageOrientation: 'none' }" class="pa-1 white avatar">
          </v-avatar>
          <v-flex class="flex-column">
            <span class="font-weight-black pf-font-14">{{ ProfileDocument.account && ProfileDocument.account.name ? ProfileDocument.account.name : 'Not Found' }}</span>
            <span class="grey--text pf-font-11 text-uppercase">Client</span>
          </v-flex>
        </v-flex>
        <!-- <v-icon xs3 class="mr-1 pf-text-teal" size="26">
          chat
        </v-icon> -->
      </v-layout>
      <v-layout v-if="isAllApproved && !ProfileDocument.submitted" class="flex-center pa-3 ma-2 pf-bg-teal flex-column border-radius-5 lh-25 pf-font-16 letter-space-1">
        <v-flex>
          <p class="font-weight-medium white--text pf-font-16 ma-0">
            Now you can submit the whole document for further profile document processing.
          </p>
        </v-flex>
        <v-flex>
          <v-btn class="pf-btn-sm-2 white pf-text-teal border-radius-15" title="Submit Final Document" @click.stop="submitFinalDocument">
            Submit Final Document
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout wrap v-else-if="ProfileDocument.submitted" class="flex-center pa-3 ma-2 pf-bg-teal border-radius-5 lh-25 pf-font-16 letter-space-1">

        <v-flex class="flex-column" :class="{ 'sm6': currentPDFStatus }">
          <p class="font-weight-medium text-xs-center white--text pf-font-16 ma-0">
            Final Document Submitted on: <span class="pf-text-menu font-weight-light">{{ ProfileDocument.submitted_date ? formatDate(ProfileDocument.submitted_date) : 'N/A' }}</span>
          </p>
          <!-- <v-flex class="flex-row flex-center">
            <v-btn class="pf-btn-sm-2 white pf-text-teal border-radius-15" title="Download ZIP" v-if="ProfileDocument.zip" target="_blank" :href="ProfileDocument.zip" @click="updateProfileDocument('downloadZIP')">
              <v-icon size="18" class="mr-2">download</v-icon>
              Download ZIP
            </v-btn>
            <upload-btn ref="uploadButton" @file-update="uploadPDF($event)" labelClass="pf-text-teal border-radius-15" color="white" noTitleUpdate title="Upload PDF" small :disabled="currentPDFStatus && currentPDFStatus.status && ['WriterReview', 'ParentReview', 'Approved'].indexOf(currentPDFStatus.status) > -1">
              <template slot="icon-left">
                  <v-icon size="18" class="mr-2" right dark>cloud_upload</v-icon>
              </template>
              <template slot="text-field"></template>
            </upload-btn>            
          </v-flex> -->
        </v-flex>

        <v-flex sm6 class="flex-column" v-if="currentPDFStatus">
          <!-- Allow writer to approve/add suggestions -->
          <template v-if="currentPDFStatus && currentPDFStatus.status === 'AgencyReview' && ProfileDocument.pdf.template.file && ProfileDocument.pdf.template.file.webPath && ((currentPDFStatus.agency && currentPDFStatus.agency.toString() === Agency.id.toString()) || Agency.is_super_admin || Agency.is_super_writer)">
            <p class="text-center white--text font-weight-medium letter-space-1 ma-0">
              Profile team has uploaded the <a class="teal-bg-link" :href="config.uploadPath + ProfileDocument.pdf.template.file.webPath" target="_blank">profile book</a>. You can approve it or add suggestions.
            </p>
            <v-flex class="flex-row flex-center">
              <v-btn
                class="pf-btn-sm-2 white pf-text-teal border-radius-15"
                title="Approve"
                @click.stop="updatePDFStatus('ParentReview')"
              >
                Approve
              </v-btn>
              <v-btn
                class="pf-btn-sm-2 white pf-text-red border-radius-15"
                title="Suggestion"
                @click.stop="updatePDFStatus('Need Attention')"
              >
                Suggestion
              </v-btn>
            </v-flex>
          </template>

          <template v-else>
            <p v-if="currentPDFStatus && currentPDFStatus.status && currentPDFStatus.status === 'WriterReview' && ProfileDocument.pdf.template.file && ProfileDocument.pdf.template.file.webPath" class="text-center white--text font-weight-medium letter-space-1 ma-0">
              The uploaded <a class="teal-bg-link" :href="config.uploadPath + ProfileDocument.pdf.template.file.webPath" target="_blank">profile book</a> is being reviewed by the writer. Please check back soon.
            </p>
            <p v-else-if="currentPDFStatus && currentPDFStatus.status && currentPDFStatus.status === 'ParentReview' && ProfileDocument.pdf.template.file && ProfileDocument.pdf.template.file.webPath" class="text-center white--text font-weight-medium letter-space-1 ma-0">
              The uploaded <a class="teal-bg-link" :href="config.uploadPath + ProfileDocument.pdf.template.file.webPath" target="_blank">profile book</a> is being reviewed by the parent. Please check back soon.
            </p>
            <p v-else-if="currentPDFStatus && currentPDFStatus.status && currentPDFStatus.status === 'Need Attention'" class="text-center white--text font-weight-medium letter-space-1 ma-0">
              Writer/Family has added <span @click.stop="viewPDFSuggestions" class="cursor-pointer pf-text-blue">suggestion(s)</span> on the <a :href="config.uploadPath + ProfileDocument.pdf.template.file.webPath" class="teal-bg-link" target="_blank">profile book</a>. Please consider them and re-upload the PDF.
            </p>
          </template>
        </v-flex>

      </v-layout>
    </v-layout>
    <div :class="{ 'mt-3': !currentDocument }">
      <v-tabs
        v-model="tabsModel"
        slider-color="#019d8c"
        class="pf-tabs-teal layout-main-tab pf-tab"
        id="top-tabs"
        @change="mainTabsChange"
      >
        <!-- <v-tab href="#tab-1"
          >
          <span class="pa-1 pf-border-light-1 border-radius-15 mr-1 section-tab-counter">1</span>
          Design Preferences
          <v-icon
            class="ml-1"
            size="18"
            :class="statusTexts[getDesignPrefStatus].class"
            >{{ statusTexts[getDesignPrefStatus].icon }}</v-icon
          >
        </v-tab> -->
        <v-tab href="#tab-2"
          >
          <span class="pa-1 pf-border-light-1 border-radius-15 mr-1 section-tab-counter">2</span>
          Chapters
          <v-icon
            class="ml-1"
            size="18"
            :class="statusTexts[getChaptersStatus].class"
            >{{ statusTexts[getChaptersStatus].icon }}</v-icon
          ></v-tab
        >
        <v-tab href="#tab-3"
          >
          <span class="pa-1 pf-border-light-1 border-radius-15 mr-1 section-tab-counter">3</span>
          Covers & Spread
          <v-icon
            class="ml-1"
            size="18"
            :class="statusTexts[coverStatus].class"
            >{{ statusTexts[coverStatus].icon }}</v-icon
          ></v-tab
        >

        <!-- <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <template v-if="!currentTemplate">
                <span class="pa-4 grey--text pf-font-16">Parent did not submit their design preferences.</span>
              </template>
              
              <template v-else>
                
                <v-layout>
                  <p class="font-weight-regular pf-font-16 grey--text ma-0">
                    Design style: <span class="grey--text text--darken-1 font-weight-black">{{ currentTemplate.name }}</span>
                  </p>
                </v-layout>

                <v-layout wrap class="pa-3 mt-2">
                  <v-flex sm4 md2 class="flex-column flex-center pa-3">
                    <div class="flex-column flex-center cursor-pointer" title="Click to view" @click="/* viewFlipbook() */{}">
                      <a :href="currentTemplate.file" target="_blank">
                        <v-hover v-slot="{ hover: designHover }">
                          <div class="pf-pos-relative">
                            <img class="pf-width-100p" :src="getFlipbookFirstPage()" />
                            <v-flex class="design-overlay flex-center" v-if="designHover">
                              <v-icon class="pf-text-white" size="22">search</v-icon>
                            </v-flex>
                          </div>
                        </v-hover>
                      </a>
                    </div>
                  </v-flex>
                </v-layout>

              </template>

              <next-button @next-clicked="() => { goToNextStep('2') }"></next-button>

            </v-card-text>
          </v-card>
          <app-modal :active="flipbookViewModal" v-if="flipbookViewModal" width="100%" :fullWidth="true">
            <div slot="modal-content">
              <v-card>
                <v-layout class="flex-end">
                  <v-btn icon dark @click="closeFlipbookView">
                    <v-icon class="black--text">close</v-icon>
                  </v-btn>
                </v-layout>

                <v-layout>
                  <iframe :height="windowHeight" width="100%" frameborder="0" :src="currentTemplate.file" class="pf-border-dark-1"></iframe>
                </v-layout>
              </v-card>
            </div>
          </app-modal>
        </v-tab-item> -->
        <v-tab-item value="tab-2">
          <v-card flat :class="{ 'no-shadow': currentDocument }">
            <v-card-text :class="{ 'pa-0': currentDocument }" id="chapter-content-tabs">
              <template v-if="currentDocument">
                <v-layout class="flex-start mb-3">
                  <v-flex class="flex-row">
                    <!-- <v-btn icon flat class="pf-text-teal" @click="backToListing">
                      <v-icon size="24" class="pr-1">arrow_back</v-icon>
                    </v-btn> -->
                    <v-btn fab @click="backToListing" class="pf-btn-fab-sm">
                      <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <span class="font-weight-bold ml-2 pf-font-20 letter-space-p5">{{
                      currentDocument.name
                    }}</span>
                  </v-flex>
                </v-layout>

                <v-tabs
                  v-model="chapterTabs"
                  slider-color="#019d8c"
                  class="mt-2 pf-tabs-teal pf-tab inner-tabs"
                  @change="chapterTabsChange"
                >
                  <v-tab href="#tab-1">Content</v-tab>
                  <v-tab href="#tab-2">Photos</v-tab>

                  <v-tab-item value="tab-1">
                    <!-- <v-card flat> -->
                    <v-card-text class="pa-0">
                      <!-- Content -->
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-layout wrap :class="{ 'flex-space-between': $vuetify.breakpoint.smAndUp }">
                            <v-flex sm6>
                              <v-layout class="flex-column">
                                <v-layout :class="{ 'flex-row': $vuetify.breakpoint.smAndUp }">

                                  <div v-if="currentDocument.content.revision[currentDocument.content.revision.length - 1].owner !== 'Agency' && ['AgencyReview'].indexOf(currentDocument.content.status) > -1">
                                    <v-btn class="pf-btn-sm-2 pf-bg-green border-radius-15" title="Approve" @click.stop="updateContentStatus('Approved')">
                                      Approve
                                    </v-btn>
                                    <v-btn class="pf-btn-sm-2 pf-bg-pink border-radius-15" title="Revise Content" @click.stop="editContent">
                                      Revise
                                    </v-btn>
                                  </div>

                                  <p v-else class="font-weight-regular pf-font-16 grey--text ma-0">
                                    Content to be used in this chapter
                                  </p>

                                  <!-- <item-status class="ml-2" :status="currentDocument.content.status" :statusTexts="statusTexts"></item-status> -->

                                </v-layout>

                                <v-layout :class="{ 'flex-row': $vuetify.breakpoint.smAndUp }">

                                  <v-flex class="mt-2" v-if="currentDocument.content.status === 'AgencyReview'">
                                    <p class="ma-0 pf-font-16 grey--text">
                                      You may approve or revise the content approved by the writer
                                    </p>
                                  </v-flex>

                                  <p
                                    v-else-if="currentDocument.content.status === 'Approved'"
                                    class="font-weight-normal pf-text-teal pf-font-14 ma-0 mt-2"
                                  >
                                    Approved on: {{ formatDate(currentDocument.content.status_date) }}
                                  </p>

                                </v-layout>
                              </v-layout>

                            </v-flex>

                            <v-flex :class="{ 'flex-end': $vuetify.breakpoint.smAndUp }">

                              <item-status class="ml-2" :status="currentDocument.content.status" :statusTexts="statusTexts"></item-status>

                              <v-btn :disabled="currentDocument.content.revision.length < 2" flat class="pf-btn-sm-2 pf-text-teal" title="Split Screen" @click.stop="toggleSplitScreen">
                                <v-icon v-if="!splitContentRevision" size="18" class="pr-1">vertical_split</v-icon>
                                <v-icon v-else size="18" class="pr-1">close</v-icon>
                                <span class="pf-font-12"
                                  >Split Screen</span
                                >
                              </v-btn>
                              <div class="flex-row">
                                <v-flex class="border-radius-left-5 pf-border-teal-1 px-2 py-1 pf-cursor-pointer flex-row" :class="{ 'pf-bg-teal': showTips }">
                                  <div @click.stop="showCommentsTips('tips')">
                                    <v-icon :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="18">info</v-icon>
                                    <span :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }">Tips</span>
                                  </div>
                                  <!-- <v-icon class="ml-2" :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="20">volume_up</v-icon> -->
                                </v-flex>
                                <v-flex class="pf-border-teal-1 px-2 py-1 border-radius-right-5 pf-cursor-pointer" @click.stop="showCommentsTips('comments')" :class="{ 'pf-bg-teal': showComments }">
                                  <v-icon :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }" size="18">chat</v-icon>
                                  <span :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }">Comments</span>
                                </v-flex>
                              </div>
                            </v-flex>
                          </v-layout>

                          <v-layout wrap>
                            <v-flex :class="{ 'sm8': showTips || showComments }">

                              <!-- <v-layout class="mt-2" v-if="!ProfileDocument.submitted && currentDocument.content.revision[currentDocument.content.revision.length - 1].owner === 'Writer' && currentDocument.content.status === 'Suggestion' && enableContentSave && !isContentSubmitted">
                                <v-flex>
                                  <p class="ma-0 font-italic pf-font-14 grey--text">
                                    Once you have finished writing for this chapter, please submit for approval.
                                  </p>
                                </v-flex>
                              </v-layout> -->

                              <v-layout :class="{ 'wrap': splitContentRevision }">
                                <v-flex class="mt-3" :class="{ sm6: splitContentRevision }">
                                  <v-tabs
                                    v-model="contentsModel"
                                    slider-color="#019d8c"
                                  class="pf-tabs-teal-sm pf-tab inner-tabs"
                                    height="35"
                                  >
                                  <template
                                    v-for="(contentVersion, r) in (currentDocument.content.revision && splitContentRevision && (currentDocument.content.revision.filter(x => x.owner === 'Parent')).length ? currentDocument.content.revision.filter(x => x.owner === 'Parent') : (currentDocument.content.revision.length ? currentDocument.content.revision : []))">
                                    <v-tab
                                      :href="`#tab-${r + 1}`"
                                      :key="r"
                                      >{{ r + 1 }}
                                    </v-tab>
                                    <v-tab-item
                                      :value="`tab-${r + 1}`"
                                      :key="r + currentDocument.content.revision.length + 1">
                                      <v-card-text class="pa-0" :class="{ 'errorEditor': isWordsExceeded }">
                                        <v-layout>
                                          <p><span class="font-italic">Version {{ r + 1 }} by <span class="font-weight-black">{{ contentVersion.owner || 'N/A' }}</span></span>
                                            <small class="ml-1 pf-text-warning"
                                              v-if="r !== currentDocument.content.revision.length - 1 ||
                                              contentVersion.owner !== 'Agency' ||
                                              ['Review', 'AgencyReview', 'Approved'].indexOf(currentDocument.content.status) > -1">
                                              (read only)
                                            </small>
                                            <span class="ml-2 grey--text" v-else-if="!isWordsExceeded">
                                              ({{ remainingWords }} word{{ remainingWords !== 1 ? 's' : '' }} left of {{ (profileSettings.content_word_count || 250) }})
                                            </span>
                                            <span class="ml-2 pf-text-red" v-else>
                                              (Words count exceeded the limit of {{ (profileSettings.content_word_count || 250) }}, {{ remainingWords * (-1) }} extra words)
                                            </span>
                                          </p>
                                        </v-layout>
                                        <editor
                                          v-if="r === currentDocument.content.revision.length - 1"
                                          :options="editorOption"
                                          @onKeyUp="contentChanged" @onChange="contentChanged"
                                          :content="content"
                                          :init="init"
                                          :api-key="config.tinymceEditorKey"
                                          :disabled="r !== currentDocument.content.revision.length - 1 || contentVersion.owner !== 'Agency' || ProfileDocument.submitted || ['WriterReview', 'Approved'].indexOf(currentDocument.content.status) > -1"
                                          v-model="currentRevisionContent"
                                        />
                                        <editor
                                          v-else
                                          :options="editorOption"
                                          @onKeyUp="contentChanged" @onChange="contentChanged"
                                          :content="content"
                                          :init="init"
                                          :api-key="config.tinymceEditorKey"
                                          :disabled="r !== currentDocument.content.revision.length - 1 || contentVersion.owner !== 'Agency' || ProfileDocument.submitted || ['WriterReview', 'Approved'].indexOf(currentDocument.content.status) > -1"
                                          v-model="contentVersion.text"
                                        />
                                        <!-- Tail texts -->
                                        <v-flex class="flex-space-between">
                                            <div>
                                              <span v-if="r !== currentDocument.content.revision.length - 1 || ['Review', 'AgencyReview'].indexOf(currentDocument.content.status) === -1" class="grey--text font-italic">Revision created on: {{ formatDate(contentVersion.date) }}</span>
                                              <span v-else-if="currentDocument.content.status === 'Approved'" class="grey--text font-italic">Revision approved on: {{ formatDate(currentDocument.content.status_date) }}</span>
                                              <span v-else-if="['Review', 'AgencyReview'].indexOf(currentDocument.content.status) > -1" class="grey--text font-italic">Revision submitted on: {{ formatDate(currentDocument.content.status_date) }}</span>
                                            </div>
                                            <span v-if="r === currentDocument.content.revision.length - 1 && contentVersion.owner === 'Agency'" class="grey--text font-italic">Maximum words count: {{ profileSettings.content_word_count || 250 }}</span>
                                        </v-flex>
                                      </v-card-text>
                                    </v-tab-item>
                                  </template>
                                  </v-tabs>

                                </v-flex>
                                <v-flex class="mt-3 sm6" v-if="splitContentRevision">
                                  <v-tabs
                                    v-model="contentsSplitModel"
                                    slider-color="#019d8c"
                                    class="pf-tabs-pink-sm pf-tab"
                                    height="35"
                                  >
                                  <template v-for="(contentVersion, r) in (currentDocument.content.revision && (currentDocument.content.revision.filter(x => x.owner === 'Agency')).length ? currentDocument.content.revision.filter(x => x.owner === 'Agency') : (currentDocument.content.revision.length ? currentDocument.content.revision : []))">
                                    <v-tab :href="`#tab-${r + 1}`" class="pf-menu-text" :key="r"
                                      >{{ r + 1 }}
                                    </v-tab>
                                    <v-tab-item :value="`tab-${r + 1}`" :key="(r + currentDocument.content.revision.length + 1)">
                                      <v-card-text class="pa-0" :class="{ 'errorEditor': isWordsExceeded }">
                                        <v-layout>
                                          <p>
                                            <span class="font-italic">Version {{ r + 1 }} by <span class="font-weight-black">{{ contentVersion.owner || 'N/A' }}</span></span>
                                            <small class="ml-1 pf-text-warning" v-if="r !== currentDocument.content.revision.length - 1 || contentVersion.owner !== 'Agency'">(read only)</small>
                                            <span class="ml-2 grey--text" v-else-if="!isWordsExceeded">
                                              ({{ remainingWords }} word{{ remainingWords !== 1 ? 's' : '' }} left of {{ (profileSettings.content_word_count || 250) }})
                                            </span>
                                            <span class="ml-2 pf-text-red" v-else>
                                              (Words count exceeded the limit of {{ (profileSettings.content_word_count || 250) }}, {{ remainingWords * (-1) }} extra words)
                                            </span>
                                          </p>
                                        </v-layout>
                                        <editor
                                          v-if="r === currentDocument.content.revision.length - 1"
                                          :options="editorOption"
                                          @onKeyUp="contentChanged" @onChange="contentChanged"
                                          :content="content"
                                          :init="init"
                                          :api-key="config.tinymceEditorKey"
                                          :disabled="r !== currentDocument.content.revision.length - 1 || contentVersion.owner !== 'Agency' || ProfileDocument.submitted || ['WriterReview', 'Approved'].indexOf(currentDocument.content.status) > -1"
                                          v-model="currentRevisionContent"
                                        />
                                        <editor
                                          v-else
                                          :options="editorOption"
                                          @onKeyUp="contentChanged" @onChange="contentChanged"
                                          :content="content"
                                          :init="init"
                                          :api-key="config.tinymceEditorKey"
                                          :disabled="r !== currentDocument.content.revision.length - 1 || contentVersion.owner !== 'Agency' || ProfileDocument.submitted || ['WriterReview', 'Approved'].indexOf(currentDocument.content.status) > -1"
                                          v-model="contentVersion.text"
                                        />
                                        <!-- Tail texts -->
                                        <v-flex class="flex-space-between">
                                            <div>
                                              <span v-if="r !== currentDocument.content.revision.length - 1 || ['Review', 'AgencyReview'].indexOf(currentDocument.content.status) === -1" class="grey--text font-italic">Revision created on: {{ formatDate(contentVersion.date) }}</span>
                                              <span v-else-if="currentDocument.content.status === 'Approved'" class="grey--text font-italic">Revision approved on: {{ formatDate(currentDocument.content.status_date) }}</span>
                                              <span v-else-if="['Review', 'AgencyReview'].indexOf(currentDocument.content.status) > -1" class="grey--text font-italic">Revision submitted on: {{ formatDate(currentDocument.content.status_date) }}</span>
                                            </div>
                                            <span v-if="r === currentDocument.content.revision.length - 1 && contentVersion.owner === 'Agency'" class="grey--text font-italic">Maximum words count: {{ profileSettings.content_word_count || 250 }}</span>
                                        </v-flex>
                                      </v-card-text>
                                    </v-tab-item>
                                  </template>
                                  </v-tabs>

                                </v-flex>
                              </v-layout>

                              <!-- Save button -->
                              <!-- <v-flex class="mt-3 flex-end">
                                <v-btn
                                  :disabled="!enableContentSave"
                                  class="pf-btn pf-btn-save border-radius-15 pf-bg-teal"
                                  @click="updateProfileDocument('content')"
                                >
                                  <v-icon size="16" class="pr-1"
                                    >check_circle</v-icon
                                  >
                                  <div>Save</div>
                                </v-btn>
                              </v-flex> -->

                            </v-flex>

                            <v-flex v-if="showTips || showComments" sm4 class="py-2 pr-0 pl-3">
                              <profile-comments :data="ProfileDocConversation" :loadingMessages="loadingMessages" :tipsTabs="tipsTabs" :identifier="currentDocument._id" :tipsText="currentTipsText" :message="message" @send="send" @close="closeCommentsTips"></profile-comments>
                            </v-flex>

                          </v-layout>


                          <!-- Callout and notes -->
                          <v-flex class="mt-3">
                            <v-tabs
                              v-model="notesModel"
                              slider-color="#019d8c"
                              class="pf-tabs-teal-sm pf-tab"
                              height="35"
                            >
                              <v-tab href="#tab-1" class="pf-menu-text">Callout</v-tab>
                              <v-tab href="#tab-2" class="pf-menu-text">Notes</v-tab>
                              <v-tab-item value="tab-1">
                                <v-card-text>
                                  <span v-if="!currentDocument.callouts || !currentDocument.callouts.length" class="pf-font-14 font-weight-light">No callouts found, please add.</span>
                                  <v-flex class="pa-3 mt-3 pf-bg-light-2 border-radius-15" v-for="(callout, c) in currentDocument.callouts || []" :key="c">
                                    <p>{{ callout }}</p>
                                  </v-flex>

                                  <!-- To add new callout -->
                                  <v-layout wrap class="flex-start mt-3">
                                    <v-flex sm6>
                                      <v-textarea label="Add new callout" class="ma-0" v-model="newCallout" rows="3"></v-textarea>
                                    </v-flex>
                                    <v-flex sm2>
                                      <v-btn class="pf-btn-sm-2 pf-bg-teal border-radius-15" title="Add Callout" :disabled="!newCallout || !newCallout.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length" @click.stop="addCallout">
                                        <v-icon size="16" class="ml-1">add</v-icon>
                                        Add Callout
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>

                                </v-card-text>
                              </v-tab-item>

                              <v-tab-item value="tab-2">
                                <v-card-text>
                                  <span v-if="!currentDocument.notes || !currentDocument.notes.length" class="pf-font-14 font-weight-light">No notes found, please add.</span>
                                  <v-flex class="pa-3 mt-3 pf-bg-light-2 border-radius-15" v-for="(note, n) in currentDocument.notes || []" :key="n">
                                    <p>{{ note }}</p>
                                  </v-flex>

                                  <!-- To add new note -->
                                  <v-layout wrap class="flex-start mt-3">
                                    <v-flex sm6>
                                      <v-textarea label="Add new note" class="ma-0" v-model="newNote" rows="3"></v-textarea>
                                    </v-flex>
                                    <v-flex sm2>
                                      <v-btn class="pf-btn-sm-2 pf-bg-teal border-radius-15" title="Add Note" :disabled="!newNote || !newNote.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length" @click.stop="addNote">
                                        <v-icon size="16" class="ml-1">add</v-icon>
                                        Add Note
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>

                                </v-card-text>
                              </v-tab-item>
                            </v-tabs>

                          </v-flex>

                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <!-- </v-card> -->
                  </v-tab-item>
                  <v-tab-item value="tab-2">
                    <!-- <v-card flat> -->
                    <v-card-text class="pa-0">
                      <!-- Content -->

                      <v-layout wrap :class="{ 'flex-space-between': $vuetify.breakpoint.smAndUp }">
                        <v-flex sm6 class="flex-row">
                          <!-- <v-btn icon flat class="pf-text-teal" @click="closeAddPhotos" v-if="addingPhotos">
                            <v-icon size="24" class="pr-1">arrow_back</v-icon>
                          </v-btn> -->
                          <p class="font-weight-regular pf-font-16 grey--text ma-0">
                            Photos to be used in this chapter
                          </p>
                        </v-flex>
                        <v-flex :class="{ 'flex-end': $vuetify.breakpoint.smAndUp }">
                          <div class="flex-row">
                            <v-flex class="border-radius-left-5 pf-border-teal-1 px-2 py-1 pf-cursor-pointer flex-row" :class="{ 'pf-bg-teal': showTips }">
                              <div @click.stop="showCommentsTips('tips')">
                                <v-icon :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="18">info</v-icon>
                                <span :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }">Tips</span>
                              </div>
                              <!-- <v-icon class="ml-2" :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="20">volume_up</v-icon> -->
                            </v-flex>
                            <v-flex class="pf-border-teal-1 px-2 py-1 border-radius-right-5 pf-cursor-pointer" @click.stop="showCommentsTips('comments')" :class="{ 'pf-bg-teal': showComments }">
                              <v-icon :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }" size="18">chat</v-icon>
                              <span :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }">Comments</span>
                            </v-flex>
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap>
                        <v-flex :class="{ 'sm8': showTips || showComments }">

                          <v-layout wrap v-if="isPhotoView && currentPhoto" class="pa-3">
                            <v-flex class="pf-border-lighter-1">
                              <v-flex class="grey lighten-4 pf-border-bottom-lighter-1 flex-space-between pa-3">
                                
                                <item-status class="flex" :status="currentPhoto.status" :statusTexts="statusTexts"></item-status>

                                <span class="font-weight-medium">Size: {{ currentPhoto.photo.size ? `${(currentPhoto.photo.size / 1000000).toFixed(2)} MB` : 'unknown' }}{{ currentPhotoDim ? `, Dimension: ${currentPhotoDim}` : '' }}</span>

                                <v-flex class="flex-end">
                                  <v-icon class="pf-text-teal" size="26" @click="changeCurrentPhoto('back')">arrow_back_ios</v-icon>
                                  <span class="font-italic">{{ currentPhotoIndex + 1 }} of {{ currentDocument.items.length }}</span>
                                  <v-icon class="pf-text-teal" size="26" @click="changeCurrentPhoto('next')">arrow_forward_ios</v-icon>
                                  <v-icon class="flex-end ml-4 pf-text-teal" title="Close" @click="closeViewPhoto" size="24">close</v-icon>
                                </v-flex>
                              </v-flex>
                              
                              <v-layout v-if="currentPhoto.status === 'AgencyReview'" class="grey lighten-4 pa-1 pf-border-bottom-lighter-1 flex-center">
                                <v-btn
                                  class="pf-btn-sm-2 pf-bg-green border-radius-15"
                                  title="Approve"
                                  @click.stop="updatePhotoStatus('Approved')"
                                >
                                  Approve
                                </v-btn>
                                <v-btn
                                  class="pf-btn-sm-2 pf-bg-red border-radius-15"
                                  title="Suggestion"
                                  @click.stop="updatePhotoStatus('AgencyReplace')"
                                >
                                  Suggestion
                                </v-btn>
                              </v-layout>

                              <!-- <v-layout class="mt-2 flex-space-between pf-width-xs100p margin-auto-15" :class="{ 'pf-width-50p': $vuetify.breakpoint.smAndUp }">
                              </v-layout> -->

                              <v-layout wrap class="pa-3 grey lighten-3 flex-center flex-column">
                                <v-flex sm6>
                                  <a :href="currentPhoto.photo.original_url" target="_blank">
                                    <img class="image-view" :src="currentPhoto.photo.webview_url" />
                                  </a>
                                </v-flex>
                                <p class="ma-0">
                                  <label class="font-weight-black">Photo Caption: </label><span>{{ currentPhoto.photo.caption || 'No Caption' }}</span>
                                </p>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                          <template v-else>
                            <v-layout class="flex-column" v-if="!currentDocument.items.length && !addingPhotos">
                              <v-flex
                                class="pf-bg-light-2 pf-border-teal-dash-1 mt-3 pa-4 flex-center flex-column"
                              >
                                <span class="font-weight-light pf-font-14"
                                  >0 Photos</span
                                >
                                <v-btn
                                  flat
                                  v-if="!ProfileDocument.submitted"
                                  class="pf-btn-sm-2 pf-text-teal"
                                  title="Add Photos"
                                  @click.stop="selectPhotos"
                                >
                                  <v-icon>add</v-icon>
                                  Add Photos
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <v-layout wrap v-if="chapterTabs === 'tab-2'" class="flex-top mt-2">
                              <v-flex :class="{ 'pr-3 sm4': addingPhotos }">
                                <div :class="{ 'pf-border-lighter-1': currentDocument.items.length || addingPhotos }">
                                  <v-layout class="pf-bg-teal pa-2" v-if="currentDocument.items.length || addingPhotos">
                                    <v-flex xs10 class="pa-1 pf-font-16 white--text font-weight-medium letter-space-1">Chapter Photos</v-flex>
                                    <v-flex xs2 class="flex-end pa-1 pf-font-16 white--text font-weight-light">({{ currentDocument.items ? currentDocument.items.length : 0 }})</v-flex>
                                  </v-layout>

                                  <!-- Remove and add more photos -->
                                  <v-layout :class="{ 'flex-space-between': $vuetify.breakpoint.smAndUp, 'flex-column': !$vuetify.breakpoint.smAndUp }" v-if="!addingPhotos && currentDocument.items.length" class="pt-2 mt-1">
                                    <v-flex class="ml-1" :class="{ 'flex-end': $vuetify.breakpoint.smAndUp }">
                                      <v-btn
                                        v-if="selectedPhotos.length && !ProfileDocument.submitted"
                                        class="pf-btn-sm-2 border-radius-15 pf-bg-teal text-capitalize"
                                        @click="unAssignSelectedPhotos"
                                      >
                                        <v-icon size="16" class="mr-1"
                                          >do_not_disturb_on</v-icon
                                        >
                                        <div class="letter-space-1">Remove Selected</div>
                                      </v-btn>
                                      <v-btn
                                        v-if="!ProfileDocument.submitted && !addingPhotos"
                                        flat
                                        class="pf-btn-sm-2 pf-text-teal text-capitalize letter-space-1"
                                        title="Add More Photos"
                                        @click.stop="selectPhotos"
                                        :disabled="currentDocument.items && currentDocument.items.length >= profileSettings.max_chapter_photos"
                                      >
                                        <v-icon class="mr-1">add_circle</v-icon>
                                        Add More Photos
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout class="flex-column pa-2" v-if="currentDocument.items.length">
                                    <v-layout v-for="(datePhotos, s) in groupedChapterPhotos" :key="s" class="mt-3 flex-column">
                                      <v-flex class="ml-1 flex-space-between">
                                        <span class="grey--text font-italic pf-font-14">
                                          {{ datePhotos.length }} Photo{{ datePhotos.length > 1 ? 's' : '' }}
                                        </span>
                                        <v-flex class="flex-end">
                                          <span class="grey--text font-weight-normal">Submitted on: {{ s !== 'N/A' ? formatDate(s) : s }}</span>
                                        </v-flex>
                                      </v-flex>
                                      <v-layout wrap v-if="chapterTabs === 'tab-2'">
                                        <isotope :ref="`chapterImages_${Object.keys(groupedChapterPhotos).indexOf(s)}`" v-if="datePhotos.length" :options="getOptions()" v-images-loaded:on.progress="layout" :list="datePhotos" class="pf-width-100p">
                                          <v-flex v-for="(photo, p) in datePhotos" :key="p" class="pa-2 chapter-item xs12 sm3 md2" :class="{ 'sm4 md3': !addingPhotos && (showTips || showComments), 'sm6 md12': addingPhotos && (showTips || showComments), 'sm3 md2': !addingPhotos, 'sm6 md6': addingPhotos }">
                                            <div class="pf-cursor-pointer pf-pos-relative flex-center" @click="viewPhoto(photo, p)" :class="{ 'pf-border-green-3': selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1 }" title="Click to manage">
                                              <v-card class="border-radius-5 pf-box-shadow">
                                                <div
                                                  v-if="['Approved', 'Replace', 'Review', 'AgencyReview', 'AgencyReplace'].indexOf(photo.status) > -1"
                                                  class="pa-2 flex-center"
                                                >
                                                  <v-icon
                                                    class="image_icon mr-1"
                                                    size="16"
                                                    :class="statusTexts[photo.status].class"
                                                  >
                                                    {{ statusTexts[photo.status].icon }}
                                                  </v-icon>
                                                  <span
                                                    :class="statusTexts[photo.status].class"
                                                    class="pf-font-12 font-weight-medium letter-space-1"
                                                  >
                                                    {{ statusTexts[photo.status].text }}
                                                  </span>
                                                </div>
                                                <v-hover v-slot="{ hover: imageHover }">
                                                  <div class="pf-pos-relative">
                                                    <img class="pf-width-100p" :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`" alt="Caption">
                                                    <v-btn absolute v-if="imageHover && photo.status !== 'Approved'" title="Remove photo" icon flat @click.stop="removePhoto(photo)" class="white top-right">
                                                      <v-icon class="pf-text-teal" size="18">delete</v-icon>
                                                    </v-btn>
                                                    <v-layout class="wrap">
                                                      <v-flex xs12 class="flex-start pa-1">
                                                        <span class="pf-font-12 pa-1 font-weight-regular">{{photo.photo.caption || 'No Caption'}}</span>
                                                      </v-flex>
                                                    </v-layout>
                                                  </div>
                                                </v-hover>
                                              </v-card>
                                            </div>
                                          </v-flex>
                                        </isotope>
                                      </v-layout>
                                    </v-layout>
                                  </v-layout>
                                  <v-flex v-else-if="addingPhotos" class="flex-center flex-column pa-2">
                                    <p class="text-center ma-0 grey--text letter-space-p5 font-italic" v-if="!selectedPhotos.length">To add photos to this chapter, select photos from your albums or upload new photos.</p>
                                    <v-flex class="square-100 grey lighten-2 grey--text pf-font-20 font-weight-medium flex-center mt-3">None</v-flex>
                                  </v-flex>

                                </div>
                              </v-flex>
                              <v-flex sm8 v-if="addingPhotos" class="flex-column">
                                <!-- Select photos -->
                                <v-layout class="flex-column pf-border-lighter-1">
                                  <!-- Top bar -->
                                  <v-flex class="grey darken-1 flex-space-between pa-1">
                                    <span class="white--text letter-space-1 ml-3 font-weight-medium pf-font-16">
                                      Photos{{ currentAlbum ? ` / ${currentAlbum.name}` : '' }}
                                    </span>
                                    <v-btn
                                      icon
                                      flat
                                      class="white--text"
                                      @click="closeAddPhotos"
                                    >
                                      <v-icon size="18" class="pr-1">close</v-icon>
                                    </v-btn>
                                  </v-flex>

                                  <!-- Upload photos -->
                                  <v-flex
                                    class="pf-bg-light-2 pf-border-pink-dash-1 ma-3 pa-2 flex-center pf-width-50p margin-auto-15"
                                  >
                                    <v-btn
                                      flat
                                      class="pf-btn pf-text-teal"
                                      title="Upload Photos"
                                      @click="addImage()"
                                    >
                                      <v-icon>file_upload</v-icon>
                                      Upload New Photos
                                    </v-btn>
                                  </v-flex>

                                  <!-- Albums and photos tabs -->
                                  <v-tabs
                                    v-model="photosTabs"
                                    slider-color="#808080"
                                    class="pf-tab pf-tabs-flat chapter-photo-tabs pl-2 pr-2"
                                  >
                                    <v-tab href="#tab-1">Albums<small class="ml-1">({{ listingAlbums.length }})</small></v-tab>
                                    <v-tab href="#tab-2">All Photos<small class="ml-1">({{ allPhotos.length || 0 }})</small></v-tab>
                                    <v-tab href="#tab-3">Printable Images<small class="ml-1">({{ printableImages.length || 0 }})</small></v-tab>

                                    <v-tab-item value="tab-1">
                                      <v-card-text class="pa-0" v-if="photosTabs === 'tab-1'">
                                        <p v-if="!listingAlbums.length" class="grey--text pf-font-14">
                                          No albums found
                                        </p>
                                        <template v-else-if="currentAlbum">
                                          <v-layout class="flex-start">
                                            <v-btn icon flat class="pf-text-teal" @click="backFromPhotos" v-if="currentAlbum">
                                              <v-icon size="24" class="pr-1">arrow_back</v-icon>
                                            </v-btn>
                                            <span v-if="currentAlbum" class="grey--text">{{ currentAlbum.photo ? currentAlbum.photo.length : 0 }} Photos</span>
                                            <p v-if="selectedPhotos.length" class="mb-0 mr-1 grey--text pf-font-14">
                                              {{ selectedPhotos.length + " selected" }}
                                            </p>
                                          </v-layout>
                                          <v-layout wrap class="pl-2 pr-2 pb-2 pt-0">
                                            <isotope ref="profileAlbumImages" :options="getOptions()" v-images-loaded:on.progress="layoutAllPhotos" :list="currentAlbum.photo" class="pf-width-100p">
                                              <v-flex v-for="(photo, p) in currentAlbum.photo" :key="p" class="pa-1 chapter-item xs12 sm3">
                                                <div class="pf-cursor-pointer pf-pos-relative flex-center" @click="selectPhoto(photo, true)" :class="{ 'pf-border-green-3': selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1 }" title="Click to add">
                                                  <img class="pf-width-100p" :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`" :alt="photo.photo.caption">
                                                  <div class="image-metadata absolute-top-right flex-center font-weight-medium">{{ photo.photo.size ? `${(photo.photo.size / 1000000).toFixed(2)} MB` : 'Size unknown' }}</div>
                                                  <div v-if="isAlreadyAssigned(photo)" class="selected-image-overlay flex-center font-weight-medium">Already added</div>
                                                  <div v-else-if="isLowQualityImage(photo)" class="selected-image-overlay cursor-pointer flex-center font-weight-medium">Web viewable only</div>
                                                </div>
                                              </v-flex>
                                            </isotope>
                                          </v-layout>
                                        </template>
                                        <v-layout v-else wrap>
                                          <isotope ref="albumList" :options="getOptions()" v-images-loaded:on.progress="layoutAlbums" :list="listingAlbums" class="pf-width-100p">
                                            <v-flex v-for="(albumItem, a) in listingAlbums" :key="a" class="pa-1 chapter-item pf-box-shadow xs12 sm3 pf-cursor-pointer" @click="viewAlbum(albumItem, a)">
                                              <div class="pf-pos-relative flex-center">
                                                <img v-if="albumItem.default_photo" class="pf-width-100p" :src="`${albumItem.default_photo.thumb_url ? albumItem.default_photo.thumb_url : albumItem.default_photo.webview_url ? albumItem.default_photo.webview_url : albumItem.default_photo.original_url}`">
                                                <img v-else class="pf-width-100p" src="/static/album-icon.jpg">
                                              </div>
                                              <v-layout class="wrap border-top-teal-4">
                                                <v-flex xs10 class="pa-1 font-weight-medium">{{ albumItem.name || 'Un-named' }}</v-flex>
                                                <v-flex xs2 class="text-center pa-1 white--text font-weight-light pf-bg-teal">{{ albumItem.photo ? albumItem.photo.length : 0 }}</v-flex>
                                              </v-layout>
                                            </v-flex>
                                          </isotope>
                                        </v-layout>
                                      </v-card-text>
                                    </v-tab-item>
                                    <v-tab-item value="tab-2">
                                      <v-card-text class="pa-0" v-if="photosTabs === 'tab-2'">
                                        <v-layout class="flex-start">
                                          <!-- <v-btn icon flat class="pf-text-teal" @click="backFromPhotos" v-if="currentAlbum">
                                            <v-icon size="24" class="pr-1">arrow_back</v-icon>
                                          </v-btn>
                                          <span v-if="currentAlbum" class="grey--text">{{ currentAlbum.photo ? currentAlbum.photo.length : 0 }} Photos</span> -->
                                          <p v-if="selectedPhotos.length" class="mb-0 mr-1 grey--text pf-font-14">
                                            {{ selectedPhotos.length + " selected" }}
                                          </p>
                                        </v-layout>
                                        <v-layout wrap class="pl-2 pr-2 pb-2 pt-0">
                                          <isotope ref="profileAlbumImages" :options="getOptions()" v-images-loaded:on.progress="layoutAllPhotos" :list="allPhotos" class="pf-width-100p">
                                            <v-flex v-for="(photo, p) in allPhotos" :key="p" class="pa-1 chapter-item xs12 sm3">
                                              <div class="pf-cursor-pointer pf-pos-relative flex-center" @click="selectPhoto(photo, true)" :class="{ 'pf-border-green-3': selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1 }" title="Click to add">
                                                <img class="pf-width-100p" :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`" :alt="photo.photo.caption">
                                                <div class="image-metadata absolute-top-right flex-center font-weight-medium">{{ photo.photo.size ? `${(photo.photo.size / 1000000).toFixed(2)} MB` : 'Size unknown' }}</div>
                                                <div v-if="isAlreadyAssigned(photo)" class="selected-image-overlay flex-center font-weight-medium">Already added</div>
                                                <div v-else-if="isLowQualityImage(photo)" class="selected-image-overlay flex-center cursor-pointer font-weight-medium">Web viewable only</div>
                                              </div>
                                            </v-flex>
                                          </isotope>
                                        </v-layout>
                                      </v-card-text>
                                    </v-tab-item>
                                    <v-tab-item value="tab-3">
                                      <v-card-text class="pa-0" v-if="photosTabs === 'tab-3'">
                                        <v-layout class="flex-start">
                                          <p v-if="selectedPhotos.length" class="mb-0 mr-1 grey--text pf-font-14">
                                            {{ selectedPhotos.length + " selected" }}
                                          </p>
                                        </v-layout>
                                        <v-layout wrap class="pl-2 pr-2 pb-2 pt-0">
                                          <isotope ref="profileQualityImages" :options="getOptions()" v-images-loaded:on.progress="layoutQualityPhotos" :list="printableImages" class="pf-width-100p">
                                            <v-flex v-for="(photo, p) in printableImages" :key="p" class="pa-1 chapter-item xs12 sm3">
                                              <div class="pf-cursor-pointer pf-pos-relative flex-center" @click="selectPhoto(photo, true)" :class="{ 'pf-border-green-3': selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1 }" title="Click to add">
                                                <img class="pf-width-100p" :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`" :alt="photo.photo.caption">
                                                <div class="image-metadata absolute-top-right flex-center font-weight-medium">{{ photo.photo.size ? `${(photo.photo.size / 1000000).toFixed(2)} MB` : 'Size unknown' }}</div>
                                                <div v-if="isAlreadyAssigned(photo)" class="selected-image-overlay flex-center font-weight-medium">Already added</div>
                                              </div>
                                            </v-flex>
                                          </isotope>
                                        </v-layout>
                                      </v-card-text>
                                    </v-tab-item>
                                  </v-tabs>

                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </template>

                        </v-flex>
                        <v-flex v-if="showTips || showComments" sm4 class="py-2 pr-0 pl-3">
                          <profile-comments :data="ProfileDocConversation" :loadingMessages="loadingMessages" :tipsTabs="tipsTabs" :identifier="currentDocument._id" :tipsText="currentTipsText" :message="message" @send="send" @close="closeCommentsTips"></profile-comments>
                        </v-flex>
                      </v-layout>
                      
                    </v-card-text>
                    <!-- </v-card> -->
                  </v-tab-item>
                </v-tabs>
              </template>
              <template v-else>
                <!-- info and add button -->
                <!-- <v-layout
                  class="font-weight-light mt-2 font-italic flex-center flex-space-between"
                >
                  <v-flex>
                    <p class="ma-0 grey--text font-weight-regular">
                      Click on a chapter to add/edit content and photos. Drag and drop to reorder.
                    </p>
                  </v-flex>
                  <v-flex class="flex-end">
                    <v-btn
                      flat
                      class="pf-btn pf-text-teal"
                      title="Add Chapter"
                      @click="addChapter"
                      :disabled="(ProfileDocument.chapters && ProfileDocument.chapters.length >= (profileSettings.max_chapters || 10) || ProfileDocument.submitted)"
                      
                    >
                      <v-icon class="mr-1">add_circle</v-icon>
                      <span class="text-capitalize font-weight-medium font-normal">New Chapter</span>
                    </v-btn>
                  </v-flex>
                </v-layout> -->

                <v-layout class="mt-3">
                  <draggable
                    v-model="ProfileDocument.chapters"
                    class="layout wrap"
                    handle=".chapterSortHandle"
                    @start="drag = true"
                    @end="drag = false"
                    @change="sortChapters"
                    forceFallback="false"
                  >
                    <v-flex
                      class="mb-3 single"
                      :class="{ 'xs12': $vuetify.breakpoint.xsOnly, 'sm4': $vuetify.breakpoint.smOnly, 'md-20p': $vuetify.breakpoint.mdAndUp }"
                      v-for="(chapter, i) in ProfileDocument.chapters"
                      :key="i"
                    >
                      <v-layout class="pa-3 flex-column">
                        <v-flex class="flex-space-between">
                          <span class="pf-font-15 grey--text text--darken-2 letter-space-1p5 text-uppercase font-weight-medium">Chapter {{ i + 1 }}</span>
                          <v-btn icon class="ma-0 chapterSortHandle" title="Change Order">
                            <v-icon size="20" color="grey lighten-1">open_with</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-layout class="flex-column overflow-hide pf-box-shadow-2 mt-1 border-radius-5 pt-3 pl-3 pr-3 cursor-pointer pf-width-100p" @click.stop="viewChapter(chapter, i)">
                          <v-layout
                            class="flex-column flex-center pf-pos-relative pb-2"
                          >
                            <span class="font-weight-black pf-font-16 letter-space-1">
                              {{ chapter.name }}
                            </span>

                            <!-- items -->
                            <span class="mt-3 font-weight-medium pf-font-12" @click.stop="selectPhotos(chapter, i)">
                              <span v-if="!chapter.items.length">0 Photos</span>
                              <span v-else>{{ currentChapterPhoto(i) }} of {{ chapter.items.length }} Photos</span>
                            </span>
                            <v-flex
                              v-if="!chapter.items.length"
                              class="pf-bg-light-2 pf-border-teal-dash-1 mt-1 pa-2 flex-center flex-column square-110"
                              @click.stop="selectPhotos(chapter, i)"
                            >
                              <!-- <span class="font-weight-black pf-font-12"
                                >0 Photos</span
                              > -->
                              <v-btn
                                flat
                                class="pf-btn-sm pf-text-teal"
                                title="Add Photos"
                                @click.stop="selectPhotos(chapter, i, true)"
                              >
                                <v-icon>add</v-icon>
                                Photos
                              </v-btn>
                            </v-flex>
                            <v-flex
                              v-else
                              class="flex-center flex-column pf-width-100p mt-1"
                            >
                              <!-- <span class="font-weight-black pf-font-12"
                                >{{ chapter.items.length }} Photos</span
                              > -->
                              <v-layout
                                wrap
                                class="flex-center"
                                @click.stop="{}"
                              >
                                <v-carousel hide-delimiters height="110" :cycle="false" class="chapter-courosel" @change="chapterSliderChanged($event, i)">
                                  <v-carousel-item
                                    v-for="(photo, p) in chapter.items.filter(x => x.photo && x.photo.thumb_url)"
                                    :key="p"
                                  >
                                    <div class="v-responsive v-image v-carousel__item" @click.stop="selectPhotos(chapter, i, true)">
                                      <div class="v-image__image v-image__image--cover" :style="`background-image: url('${photo.photo.thumb_url}'); background-position: center center;`"></div>
                                      <div class="v-responsive__content"></div>
                                    </div>
                                  </v-carousel-item>
                                </v-carousel>
                                <!-- <v-flex
                                  sm3
                                  xs2
                                  v-for="(photo, p) in chapter.items
                                    .filter(x => x.photo && x.photo.thumb_url)
                                    .slice(0, $vuetify.breakpoint.xs ? 6 : 4)"
                                  :key="p"
                                  class="pa2"
                                >
                                  <div
                                    class="border-radius-5 thumb_image"
                                    :style="
                                      `background-image: url('${photo.photo.thumb_url}')`
                                    "
                                  ></div>
                                </v-flex> -->
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout class="pt-2 mx-m15 border-top-dark-1 flex-row flex-space-between pf-width-100p">
                              <span
                                class="pa-2 mb-2 pf-font-12 font-weight-medium letter-space-1"
                                :class="statusTexts[getChapterStatus(chapter)].class"
                              >
                                <v-icon
                                  class="ml-1"
                                  size="16"
                                  :class="
                                    statusTexts[getChapterStatus(chapter)].class
                                  "
                                  >{{
                                    statusTexts[getChapterStatus(chapter)].icon
                                  }}</v-icon
                                >
                                {{
                                  statusTexts[getChapterStatus(chapter)].text
                                }}
                              </span>
                              <v-layout class="flex-end mb-2 mr-3">
                                <v-badge color="green" overlap>
                                  <!-- <template v-slot:badge>
                                    <span>3</span>
                                  </template> -->
                                  <v-icon size="20" color="grey">notifications</v-icon>
                                </v-badge>
                              </v-layout>
                            </v-layout>
                        </v-layout>
                      </v-layout>
                    </v-flex>
                  </draggable>
                </v-layout>

                <next-button @next-clicked="() => { goToNextStep('3') }"></next-button>

              </template>
              
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-3">
          <v-card flat>
            <v-card-text>
              
              <v-layout class="flex-column">
                <v-layout class="flex-space-between">
                  <v-flex>
                    <p class="grey--text font-weight-regular pf-font-16 ma-0">
                      Images can be approved or asked for replace.
                    </p>
                  </v-flex>
                  <v-flex class="flex-end">
                    <div class="flex-row">
                      <v-flex class="border-radius-left-5 pf-border-teal-1 px-2 py-1 pf-cursor-pointer flex-row" :class="{ 'pf-bg-teal': showTips }">
                        <div @click.stop="showCommentsTips('tips')">
                          <v-icon :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="18">info</v-icon>
                          <span :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }">Tips</span>
                        </div>
                        <!-- <v-icon class="ml-2" :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="20">volume_up</v-icon> -->
                      </v-flex>
                      <v-flex class="pf-border-teal-1 px-2 py-1 border-radius-right-5 pf-cursor-pointer" @click.stop="showCommentsTips('comments')" :class="{ 'pf-bg-teal': showComments }">
                        <v-icon :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }" size="18">chat</v-icon>
                        <span :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }">Comments</span>
                      </v-flex>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout wrap class="mt-3">
                  <v-flex :class="{ 'sm8': showTips || showComments }">

                    <v-layout wrap v-if="isCoverPhotoView && currentCoverPhoto" class="pa-3">
                      <v-flex class="pf-border-lighter-1">
                        <v-flex class="grey lighten-4 flex-align-center pf-border-bottom-lighter-1 flex-space-between pa-3">
                          <span class="font-weight-black pf-font-18 mb-2">{{ coverTexts[this.coverPhotoType] }}</span>
                          
                          <item-status class="flex ml-2" :status="currentCoverPhoto.status" :statusTexts="statusTexts"></item-status>

                          <span class="font-weight-medium">Size: {{ currentCoverPhoto.photo.size ? `${(currentCoverPhoto.photo.size / 1000000).toFixed(2)} MB` : 'unknown' }}{{ currentPhotoDim ? `, Dimension: ${currentPhotoDim}` : '' }}</span>
                          
                          <v-flex class="flex-end">
                            <v-icon class="flex-end ml-4 pf-text-teal" title="Close" @click="closeViewCoverPhoto" size="24">close</v-icon>
                          </v-flex>
                        </v-flex>
                        
                        <v-layout v-if="currentCoverPhoto.status === 'AgencyReview'" class="grey lighten-4 pa-3 pf-border-bottom-lighter-1 flex-center">
                          <v-btn
                            class="pf-btn-sm-2 pf-bg-green border-radius-15"
                            title="Approve"
                            @click.stop="updateCoverPhotoStatus('Approved')"
                          >
                            Approve
                          </v-btn>
                          <v-btn
                            class="pf-btn-sm-2 pf-bg-red border-radius-15"
                            title="Suggestion"
                            @click.stop="updateCoverPhotoStatus('AgencyReplace')"
                          >
                            Suggestion
                          </v-btn>
                        </v-layout>

                        <v-layout wrap class="pa-3 grey lighten-3 flex-center flex-column">
                          <v-flex sm6>
                            <a :href="getCoverImage(currentCoverPhoto.photo)" target="_blank">
                              <img class="image-view" :src="getCoverImage(currentCoverPhoto.photo)" />
                            </a>
                          </v-flex>
                          <p class="ma-0">
                            <label class="font-weight-black">Photo Caption: </label><span>{{ currentCoverPhoto.photo.caption || 'No Caption' }}</span>
                          </p>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <v-layout wrap v-else>
                      <v-flex
                        class="mb-3"
                        :class="{ 'sm8 md6': i === 1, 'sm4 md3': i !== 1 }"
                        v-for="(page, i) in specialityPictures"
                        :key="i"
                      >
                        <v-layout class="pa-3 flex-column flex-center">
                          <span
                            class="grey--text pf-font-15 letter-space-1 text-uppercase font-weight-regular"
                            >{{ page.name }}<span v-if="page.key !== 'front_cover' && !profileSettings[`${page.key}_required`]" class="ml-1 pf-font-12 text-lowercase font-italic pf-text-warning">(optional)</span></span
                          >
                          <v-layout class="flex-column overflow-hide pf-box-shadow-2 mt-1 border-radius-5 pt-3 pl-3 pr-3 cursor-pointer pf-width-100p">
                            <v-layout
                              class="flex-column flex-center pf-pos-relative"
                            >
                              <!-- items -->
                              <v-flex
                                class="mt-2"
                                v-if="getSpecialPicture(page.key)"
                                @click="viewCoverPhoto(page)"
                              >
                                <v-hover v-slot="{ hover: hoverCover }">
                                  <div class="pf-pos-relative">
                                    <img
                                      class="pf-cursor-pointer special_image"
                                      :src="getSpecialPicture(page.key)"
                                      :alt="page.key"
                                    />
                                    <v-btn absolute v-if="hoverCover && ['Approved'].indexOf(ProfileDocument.special_pictures[page.key].status) === -1" :title="`Delete ${page.name}`" icon flat @click.stop="removeSpecialPicture(page)" class="white top-right">
                                      <v-icon class="pf-text-teal" size="18">delete</v-icon>
                                    </v-btn>
                                  </div>
                                </v-hover>
                              </v-flex>

                              <v-flex
                                v-else
                                class="special_image pf-bg-light-2 pf-border-teal-dash-1 mt-1 pl-1 pr-1 pt-5 pb-5 flex-center flex-column"
                                :class="{ 'pl-5 pr-5 pt-1 pb-1': i === 1 }"
                              >
                                <span class="font-weight-black pf-font-12">{{
                                  page.size
                                }}</span>
                                <v-btn
                                  flat
                                  class="pf-btn-sm pf-text-teal"
                                  title="Add Photo"
                                  @click="addImage('special', page.name)"
                                >
                                  <v-icon>add</v-icon>
                                  Photo
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          
                            <v-layout class="pt-2 mx-m15 border-top-dark-1 flex-row flex-space-between pf-width-100p">
                              <span
                                class="pa-2 mb-2 pf-font-12 font-weight-medium letter-space-1"
                                :class="statusTexts[ProfileDocument.special_pictures && ProfileDocument.special_pictures[page.key] ? ProfileDocument.special_pictures[page.key].status : 'Pending'].class"
                              >
                                <v-icon
                                  class="ml-1"
                                  size="16"
                                  :class="statusTexts[ProfileDocument.special_pictures &&ProfileDocument.special_pictures[page.key] ? ProfileDocument.special_pictures[page.key].status : 'Pending'].class"
                                >
                                  {{ statusTexts[ProfileDocument.special_pictures && ProfileDocument.special_pictures[page.key] ? ProfileDocument.special_pictures[page.key].status : "Pending"].icon }}
                                </v-icon>

                                {{ statusTexts[ProfileDocument.special_pictures && ProfileDocument.special_pictures[page.key] ? ProfileDocument.special_pictures[page.key].status : "Pending"].text }}

                              </span>
                              <v-layout class="flex-end mb-2 mr-3">
                                <v-badge color="green" overlap>
                                  <!-- <template v-slot:badge>
                                    <span>3</span>
                                  </template> -->
                                  <v-icon size="20" color="grey">notifications</v-icon>
                                </v-badge>
                              </v-layout>
                            </v-layout>

                          </v-layout>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="showTips || showComments" sm4 class="py-2 pr-0 pl-3">
                    <profile-comments :data="ProfileDocConversation" :identifier="ProfileDocument._id" :loadingMessages="loadingMessages" :tipsTabs="tipsTabs" :tipsText="currentTipsText" :message="message" @send="send" @close="closeCommentsTips"></profile-comments>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <!-- Common modals -->
      <app-modal :active="isViewPDFSuggestions" v-if="isViewPDFSuggestions" width="50%">
        <div slot="modal-content">
          <v-card>
            <v-toolbar card dark class="pf-bg-teal">
              <v-btn class="pf-modal-close" icon dark @click="closePDFSuggestions">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Profile Book Suggestion</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <p>{{ currentPDFStatus && currentPDFStatus.description ? ('"' + currentPDFStatus.description + '"') : 'No suggestions found' }}</p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="closePDFSuggestions"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </app-modal>
      
    </div>
  </div>
</template>
<script>
/* global session store config */
/* eslint-disable */
import Vue from "vue";

const ItemStatus = Vue.component('item-status', {
  props: ['status', 'statusTexts'],
  template: `<span
    v-if="['Pending', 'Saved'].indexOf(this.status) === -1"
    class="mr-2 pf-font-12 font-weight-medium letter-space-1"
    :class="this.statusTexts[this.status].class"
  >
    <v-icon size="16" :class="this.statusTexts[this.status].class">
      {{ this.statusTexts[this.status].icon }}
    </v-icon>
    {{ this.statusTexts[this.status].text }}
  </span><span v-else></span>`
});
const NextButton = Vue.component('next-button', {
  props: [],
  template: `<v-flex class="flex-end">
              <v-btn title="Go to Next" class="pf-bg-teal white--text" flat @click.stop="$emit('next-clicked')">
                Next
              </v-btn>
            </v-flex>`
});

import { mapGetters } from "vuex";
import {
  getCollection,
  update,
  getOne,
  remove,
  getVimeoJSON,
  request,
  create,
  conversationListPopulate,
  formatDate,
  sortList,
  uploadFile
} from "../../helpers/helpers";
import swal from "sweetalert2";
import draggable from "vuedraggable";
import AppModal from "../../components/AppModal";
import ProfileComments from "./profile_comments";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import isotope from "../../components/Isotope";
import imagesLoaded from "vue-images-loaded";
import Editor from "@tinymce/tinymce-vue";
import UploadButton from 'vuetify-upload-button';

// import VuePlyr from 'vue-plyr';
// import 'vue-plyr/dist/vue-plyr.css';
// Vue.use(VuePlyr);

import VueYouTubeEmbed from "vue-youtube-embed";
Vue.use(VueYouTubeEmbed);

import { vueVimeoPlayer } from "vue-vimeo-player";

const sleep = milliseconds => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export default {
  name: "profileDocumentsParent",
  components: {
    draggable,
    "vimeo-player": vueVimeoPlayer,
    "app-modal": AppModal,
    isotope,
    imagesLoaded,
    Editor,
    VuePerfectScrollbar,
    'profile-comments': ProfileComments,
    ItemStatus,
    NextButton,
    'upload-btn': UploadButton
  },
  directives: {
    imagesLoaded
  },
  data: () => ({
    formatDate,
    tabsModel: "tabs-model",
    contentsModel: "contents-model",
    contentsSplitModel: "contents-split-model",
    chapterTabs: "chapter-tabs",
    tipsTabs: "tips-tabs",
    photosTabs: "tab-3",
    notesModel: "notes-tabs",
    documentId: null,
    session: session,
    accountDetails: {},
    selectedData: false,
    config: config,
    currentDocument: null,
    currentDocumentIndex: -1,
    currentRevisionContent: "",
    realCurrentContent: '',
    addingPhotos: false,
    profileAlbum: null,
    uploadData: {},
    editChapterIndex: -1,
    isChapterEdit: false,
    editItemCaptionIndex: -1,
    isItemCaptionEdit: false,
    showUnassigned: false,
    unassignedItems: [],
    specialityPictures: [
      {
        name: "Front Cover",
        key: "front_cover",
        size: "(576px X 720px)"
      },
      {
        name: "Center Spread",
        key: "center_spread",
        size: "(1152px X 720px)"
      },
      {
        name: "Back Cover",
        key: "back_cover",
        size: "(576px X 720px)"
      }
    ],
    statusTexts: {
      Pending: { text: "Pending", icon: "info", class: "pf-text-teal" },
      Saved: {
        text: "In Progress",
        icon: "hourglass_top",
        class: "pf-text-warning"
      },
      Review: {
        text: "Review",
        icon: "hourglass_top",
        class: "pf-text-teal"
      },
      Approved: { text: "Completed", icon: "verified", class: "pf-text-green" },
      Replace: { text: "Replace", icon: "notification_important", class: "pf-text-warning" },
      AgencyReplace: { text: "Replace", icon: "notification_important", class: "pf-text-warning" },
      Suggestion: {
        text: "Suggestion",
        icon: "assistant",
        class: "pf-text-warning"
      },
      AgencySuggestion: {
        text: "Agency Suggestion",
        icon: "assistant",
        class: "pf-text-warning"
      },
      WriterReview: {
        text: "Writer Review",
        icon: "hourglass_top",
        class: "pf-text-teal"
      },
      AgencyReview: {
        text: "Open",
        icon: "info",
        class: "pf-text-red"
      },
    },
    enableContentSave: false,
    init: {
      height: 400,
      selector: "chapterTextEditor",
      placeholder: "Write your introduction here and submit to your writing coach for review. Your writing coach will approve or suggest modifications to finalize the content.",
      paste_data_images: true,
      menubar: false,
      toolbar: "bold italic backcolor",
      plugins: ['wordcount'],
    },
    editorOption: {
      placeholder: "Write your introduction here and submit to your writing coach for review. Your writing coach will approve or suggest modifications to finalize the content."
    },
    content: "",
    selectedPhotos: [],
    front_cover: null,
    back_cover: null,
    center_spread: null,
    helpVideoList: [],
    currentHelpVideo: null,
    vuePlayerOptions: {
      controls: ["play", "progress", "current-time", "mute", "fullscreen"]
    },
    changeContentStatusMenu: false,
    changePhotosStatusMenu: false,
    loadingMessages: false,
    message: {
      content: '',
      conversation: '',
      sender: ''
    },
    isEdit: false,
    currentEditPhoto: null,
    currentEditPhotoIndex: -1,
    editPhotoItem: null,
    profileSettings: {
      content_word_count: 250,
      max_chapter_photos: 10,
      tips_text: `<h5 class="mb-2 font-weight-bold">Here are some tips to complete your profile documents.</h5><p class="font-italic">The tips goes here</p>`,
      agency_approval_required: false
    },
    newCallout: '',
    newNote: '',
    splitContentRevision: false,
    currentPhoto: null,
    currentPhotoIndex: -1,
    isPhotoView: false,
    currentPhotoDim: null,
    currentCoverPhoto: null,
    isCoverPhotoView: false,
    coverPhotoType: null,
    coverTexts: {
      'front_cover': 'Front Cover',
      'center_spread': 'Center Spread',
      'back_cover': 'Back Cover',
    },
    // design: {
    //   no_preference: false,
    //   max_colors: 10,
    //   template: '',
    //   colors: [
    //     '#8c6239',
    //     '#f15a24',
    //     '#8cc63f'
    //   ]
    // },
    // templateItems: [
    //   { name: 'Classic', file: 'https://cdn.parentfinder.com/parent/5f0af437fc253d0be2015280/Flipbook/5f0dd4c4dc32fa1373abc9fe/16_1384.html' },
    //   { name: 'Contemporary', file: 'https://cdn.parentfinder.com/parent/5ff77a5e7032fd448c419cdc/Flipbook/601492ece4dba16a41eef24f/21_1013.html' },
    //   { name: 'Minimalist', file: 'https://cdn.parentfinder.com/parent/5ffd074fa41d4526a80e894a/Flipbook/6051ed747e74d9374909e190/21_1022.html' },
    //   { name: 'Style 4', file: 'https://cdn.parentfinder.com/parent/5ff665c4775f5044c149fc0e/Flipbook/603cf2e0d6021a25405a03fd/21_1011.html' },
    //   { name: 'Style 5', file: 'https://cdn.parentfinder.com/parent/5ff67e35775f5044c14a83bb/Flipbook/601dc4c3d6fe410dc73a7195/21_1012.html' },
    //   { name: 'Style 6', file: 'https://cdn.parentfinder.com/parent/5fff93b1bc26d8324d2e1dd9/Flipbook/601c7b5ab8f6fe60c6b09cca/21_1026.html' }
    // ],
    // currentTemplate: null,
    // currentTemplateIndex: -1,
    // flipbookViewModal: false,
    topTabsDisplay: 'block',
    showComments: false,
    showTips: false,
    currentAlbum: null,
    currentAlbumIndex: -1,
    chapterPhotoSlides: {},
    isWordsExceeded: false,
    isContentSubmitted: true,
    remainingWords: null,
    currentTipsText: `<h5 class="mb-2 font-weight-bold">Here are some tips to complete your profile documents.</h5><p class="font-italic">The tips goes here</p>`,
    isViewPDFSuggestions: false
  }),
  computed: {
    ...mapGetters(["Agency", "AlbumPhoto"]),
    ProfileDocument: {
      get() {
        return store.state.ProfileDocument;
      },
      set(value) {
        store.commit("setProfileDocument", value);
      }
    },
    ProfileDocConversation: {
      get() {
        return store.state.ProfileDocConversation;
      },
      set(value) {
        store.commit("setProfileDocConversation", value);
      }
    },
    albumList: {
      get () {
        return store.state.AlbumPhotosPopulated;
      },
      set (value) {
        store.commit('setAlbumPhotosPopulated', value);
      }
    },
    defaultChapters () {
      let chapters = [];
      if (this.profileSettings && this.profileSettings.default_chapters && Object.keys(this.profileSettings.default_chapters).length) {
        this.profileSettings.default_chapters.forEach(chapter => {
          if (chapter && chapter.name) {
            if (chapter.name === 'About Us') {
              chapters.push({ name: `About ${ this.accountDetails.account_type === 'Couple' ? 'Us' : 'Me' }` });
            } else if (chapter.name === 'About Parent 1') {
              chapters.push({ name: `About ${this.accountDetails.name.split(' / ')[0]}` });
            } else if (chapter.name === 'About Parent 2' && this.accountDetails.account_type === 'Couple' && this.accountDetails.name.split(' / ')[1]) {
              chapters.push({ name: `About ${this.accountDetails.name.split(' / ')[1]}` });
            } else if (chapter.name === 'Our Home') {
              chapters.push({ name: `${ this.accountDetails.account_type === 'Couple' ? 'Our' : 'My' } Home` });
            } else {
              chapters.push({ name: chapter.name });
            }
          }
        });
      }
      return chapters;
    },
    windowHeight () {
      return window.innerHeight - 50;
    },
    listingAlbums () {
      return this.albumList && this.albumList.length ? this.albumList.filter(x => /* ['Normal', 'Profile'].indexOf(x.type) > -1 && */ x.photo && x.photo.length) : [];
    },
    allPhotos () {
      let photos = [];
      if (this.albumList.length) {
        for (let album in this.albumList) {
          if (this.albumList[album] && this.albumList[album].photo && this.albumList[album].photo.length) {
            this.albumList[album].photo.forEach(p => {
              if (this.isAlreadyAssigned(p) || this.isLowQualityImage(p)) {
                p.order = 0;
              } else {
                p.order = 1;
              }
            });
            photos = photos.concat(this.albumList[album].photo);
          }
        }
      }
      /* Sort the photos */
      photos = photos.sort((a, b) => b.order - a.order );
      return photos;
    },
    printableImages () {
      let photos = [];
      if (this.albumList.length) {
        for (let album in this.albumList) {
          if (this.albumList[album] && this.albumList[album].photo && this.albumList[album].photo.length) {
            let printableImages = this.albumList[album].photo.filter(x => !this.isLowQualityImage(x));
            printableImages.forEach(p => {
              if (this.isAlreadyAssigned(p)) {
                p.order = 0;
              } else {
                p.order = 1;
              }
            });
            photos = photos.concat(printableImages);
          }
        }
      }
      /* Sort the photos */
      photos = photos.sort((a, b) => b.order - a.order );
      return photos;
    },
    hasMediatorListener() {
      return (
        window.getApp._events &&
        window.getApp._events.NEW_ALBUM_PHOTO &&
        window.getApp._events.NEW_ALBUM_PHOTO.length
      );
    },
    currentPhotosStatus() {
      let status = "Pending";
      if (this.currentDocument) {
        if (
          this.currentDocument.items.filter(x => x.status === "Review").length
        ) {
          status = "Review";
        } else if (
          this.currentDocument.items.filter(x => x.status === "Pending").length
        ) {
          status = "Pending";
        } else if (
          this.currentDocument.items.filter(x => x.status === "Saved").length
        ) {
          status = "Saved";
        } else if (
          this.currentDocument.items.filter(x => x.status === "Suggestion")
            .length
        ) {
          status = "Suggestion";
        } else if (
          this.currentDocument.items.filter(x => x.status === "Replace").length
        ) {
          status = "Replace";
        } else if (
          this.currentDocument.items.length &&
          this.currentDocument.items.filter(x => x.status === "Approved")
            .length === this.currentDocument.items.length
        ) {
          status = "Approved";
        }
      }
      return status;
    },
    getChaptersStatus() {
      let statuses = [];
      let doc = this.ProfileDocument;
      if (doc) {
        if (doc.chapters && doc.chapters.length) {
          doc.chapters.forEach(chapter => {
            if (chapter.content && chapter.content.status) {
              statuses.push(chapter.content.status);
            } else {
              statuses.push("Pending");
            }
            if (chapter.items && chapter.items.length) {
              chapter.items.forEach(photo => {
                if (photo && photo.status) {
                  statuses.push(photo.status);
                }
              });
            } else {
              statuses.push("Pending");
            }
          });
        } else {
          statuses.push("Pending");
        }

        if (statuses.length) {
          if (statuses.indexOf("AgencyReview") > -1) {
            return 'AgencyReview';
          } else if (statuses.indexOf("Review") > -1) {
            return 'Review';
          } else if (statuses.indexOf("Pending") > -1) {
            return 'Pending';
          } else if (statuses.indexOf("Saved") > -1) {
            return 'Saved';
          } else if (statuses.indexOf("AgencySuggestion") > -1) {
            return 'AgencySuggestion';
          } else if (statuses.indexOf("Suggestion") > -1) {
            return 'Suggestion';
          } else if (statuses.indexOf("Replace") > -1) {
            return 'Replace';
          } else if (statuses.filter(x => x === "Approved").length === statuses.length) {
            return 'Approved';
          } else {
            return 'Pending';
          }
        } else {
          return 'Pending';
        }
          
      } else {
        return 'Pending';
      }
    },  
    coverStatus() {
      let statuses = [];
      let doc = this.ProfileDocument;
      if (doc) {

        if (doc.special_pictures && Object.keys(doc.special_pictures).length) {
          let special = doc.special_pictures;
          if (special.front_cover && special.front_cover.status) {
            statuses.push(special.front_cover.status);
          } else {
            statuses.push('Pending');
          }
          if (this.profileSettings.back_cover_required) {
            if (special.back_cover && special.back_cover.status) {
              statuses.push(special.back_cover.status);
            } else {
              statuses.push('Pending');
            }
          }
          if (this.profileSettings.center_spread_required) {
            if (special.center_spread && special.center_spread.status) {
              statuses.push(special.center_spread.status);
            } else {
              statuses.push('Pending');
            }
          }
        }

        if (statuses.length) {
          if (statuses.indexOf("Review") > -1) {
            return 'Review';
          } else if (statuses.indexOf("AgencyReview") > -1) {
            return 'AgencyReview';
          } else if (statuses.indexOf("Pending") > -1) {
            return 'Pending';
          } else if (statuses.indexOf("Saved") > -1) {
            return 'Saved';
          } else if (statuses.indexOf("AgencySuggestion") > -1) {
            return 'AgencySuggestion';
          } else if (statuses.indexOf("Suggestion") > -1) {
            return 'Suggestion';
          } else if (statuses.indexOf("Replace") > -1) {
            return 'Replace';
          } else if (statuses.filter(x => x === "Approved").length === statuses.length) {
            return 'Approved';
          } else {
            return 'Pending';
          }
        } else {
          return 'Pending';
        }
          
      } else {
        return 'Pending';
      }
    },
    // getDesignPrefStatus() {
    //   let statuses = [];
    //   let doc = this.ProfileDocument;
    //   if (doc && doc.design) {

    //     let design = doc.design;
    //     // if (typeof design.no_preference !== 'undefined') {
    //     //   return 'Approved';
    //     // }
    //     // if (design.colors && design.colors.length) {
    //     //   statuses.push('Approved');
    //     // } else {
    //     //   statuses.push('Pending');
    //     // }
    //     if (design.template && design.template) {
    //       statuses.push('Approved');
    //     } else {
    //       statuses.push('Pending');
    //     }

    //     if (statuses.length) {
    //       if (statuses.indexOf("Pending") > -1) {
    //         return 'Pending';
    //       } else if (statuses.filter(x => x === "Approved").length === statuses.length) {
    //         return 'Approved';
    //       } else {
    //         return 'Pending';
    //       }
    //     } else {
    //       return 'Pending';
    //     }
          
    //   } else {
    //     return 'Pending';
    //   }
    // },
    cssVars () {
      return {
        '--v-tabs-bar-display': this.topTabsDisplay
      };
    },
    clientAvatar () {
      return this.ProfileDocument.account && this.ProfileDocument.account.avatar ? this.ProfileDocument.account.avatar : '/static/profile-pic.jpg';
    },
    groupedChapterPhotos () {
      // get () {
      //   return this.setGroupedChapterPhotos(true);
      // },
      // set (value) {
      //   // 
      // }
      let datedPhotos = {};
      this.currentDocument.items.forEach(item => {
        if (item.submitted_date) {
          let date = item.submitted_date.substr(0, 10);
          if (!datedPhotos[date]) {
            datedPhotos[date] = [];
          }
          datedPhotos[date].push(item);
        } else {
          if (!datedPhotos['N/A']) {
            datedPhotos['N/A'] = [];
          }
          datedPhotos['N/A'].push(item);
        }
      });
      return datedPhotos;
    },
    isAllApproved () {
      let done = true;

      /* Content */
      if (!Object.keys(this.ProfileDocument).length) {
        return false;
      }
      this.ProfileDocument.chapters.forEach(chapter => {
        if (!chapter.content || !chapter.content.revision || !chapter.content.revision.length || chapter.content.status !== 'Approved') {
          done = false;
        }
        
        /* Chapter items */
        if (!chapter.items || !chapter.items.length) {
          done = false;
        }

        chapter.items.forEach(item => {
          if (!item || !item.photo || item.status !== 'Approved') {
            done = false;
          }
        });
      });

      /* Design */
      // if (!this.ProfileDocument.design || !this.ProfileDocument.design.template) {
      //   done = false;
      // }

      /* Covers */
      if (!this.ProfileDocument.special_pictures) {
        done = false;
      }
      if (!this.ProfileDocument.special_pictures.front_cover || !this.ProfileDocument.special_pictures.front_cover.photo || this.ProfileDocument.special_pictures.front_cover.status !== 'Approved') {
        done = false;
      }
      if (!this.ProfileDocument.special_pictures.center_spread || !this.ProfileDocument.special_pictures.center_spread.photo || this.ProfileDocument.special_pictures.center_spread.status !== 'Approved') {
        done = false;
      }
      if (!this.ProfileDocument.special_pictures.back_cover || !this.ProfileDocument.special_pictures.back_cover.photo || this.ProfileDocument.special_pictures.back_cover.status !== 'Approved') {
        done = false;
      }

      return done;

    },
    currentPDFStatus () {
      if (this.ProfileDocument.pdf && this.ProfileDocument.pdf.review_history && this.ProfileDocument.pdf.review_history.length && this.ProfileDocument.pdf.review_history[this.ProfileDocument.pdf.review_history.length - 1]) {
        return this.ProfileDocument.pdf.review_history[this.ProfileDocument.pdf.review_history.length - 1];
      }
      return null;
    }
  },
  async created() {
    if (!this.$route.params.id) {
      swal.fire({
        type: "warning",
        title: "Error",
        text: "No document ID found in the URL",
        timer: 2500,
        onClose: () => {
          return;
        }
      });
      return;
    } else {
      this.documentId = this.$route.params.id;
    }
    await this.loadProfileDocument();
    this.scrollToTop();
    await this.loadProfileSettings();
    // await this.loadProfileAlbum();
    // await this.loadAlbums();
    this.setSpecialPictures();

    /* Set the design fields if not exists */
    // if (this.ProfileDocument.design) {
    //   this.design.template = this.ProfileDocument.design.template ? this.ProfileDocument.design.template : this.design.template;

    //   let index = this.templateItems.findIndex(x => x.name === this.design.template);
    //   if (index > -1) {
    //     this.currentTemplate = this.templateItems[index];
    //     this.currentTemplateIndex = index;
    //   }
    // }

    if (this.$route.query) {
      let query = Object.assign({}, this.$route.query);
      if (query.area) {
        switch (query.area) {
          case 'Content':
            this.tabsModel = 'tab-2';
            this.chapterTabs = 'tab-1';
            break;
          case 'Photos':
            this.tabsModel = 'tab-2';
            this.chapterTabs = 'tab-2';
            break;
          case 'Covers':
            this.tabsModel = 'tab-3';
            break;
          default:
            break;
        }
      }
      if (query.chapterId) {
        let chapterIndex = this.ProfileDocument.chapters.findIndex(x => x._id.toString() === query.chapterId.toString());
        if (chapterIndex > -1) {
          this.viewChapter(this.ProfileDocument.chapters[chapterIndex], chapterIndex, !!query.area);
        }
        delete query.chapterId;
      }
      if (query.area) {
        delete query.area;
      }
      this.$router.replace({ query });
    }

    /* Disable the loading screen by default */
    window.getApp.$emit('BGProgress', true);
  },
  beforeDestroy() {
    /* Enable the loading screen */
    window.getApp.$emit('BGProgress', false);
  },
  mounted() {
    // if (!this.hasMediatorListener) {
    window.getApp.$on('NEW_MESSAGE', messageEvent => {
      if (this.currentDocument && this.ProfileDocConversation[this.currentDocument._id] && messageEvent.data && messageEvent.data.length) {
        /* Get the chapter conversation and add the last message */
        let chapterConversation = messageEvent.data.find(x => x.profile_chapter);
        if (chapterConversation && chapterConversation.last_message) {
          if (!this.ProfileDocConversation[this.currentDocument._id].message) {
            this.ProfileDocConversation[this.currentDocument._id].message = [];
          }
          this.ProfileDocConversation[this.currentDocument._id].message.push({ message: chapterConversation.last_message });
          this.ProfileDocConversation = this.ProfileDocConversation;
        }
      }
    });
    window.getApp.$on("NEW_ALBUM_PHOTO", async messageEvent => {
      this.isListEmpty = false;
      console.log("------------>>>>>>>", "Album Profile Images", messageEvent);
      if (messageEvent.data) {
        let albumId = messageEvent.data.album;
        let newImage = messageEvent.data;
        let existingImage = false;

        /* Do only for the profile album */
        if (
          this.accountDetails.profile_album &&
          this.accountDetails.profile_album === albumId
        ) {
          /* Push to the album store first */
          if (!this.AlbumPhoto[albumId]) {
            this.AlbumPhoto[albumId] = [];
          }
          if (this.AlbumPhoto[albumId].length > 0) {
            if (
              this.AlbumPhoto[albumId].find(item => item.id === newImage.id)
            ) {
              existingImage = true;
            }
            if (!existingImage) {
              this.AlbumPhoto[albumId].push(newImage);
            }
          }
          /* Push to the ProfileDocument chapters */
          if (
            this.ProfileDocument.chapters &&
            this.ProfileDocument.chapters.length
          ) {
            /* Identify the chapter */
            let chapterName = null;
            let index = -1;
            let isKeyChapterIndex = -1;
            Object.keys(this.uploadData).forEach(key => {
              isKeyChapterIndex = this.ProfileDocument.chapters
                .map(c => c.name)
                .indexOf(key);
              index =
                isKeyChapterIndex > -1
                  ? this.uploadData[key].indexOf(newImage.filename)
                  : -1;
              if (index > -1) {
                chapterName = key;

                /* Clear the file from uploadData */
                this.uploadData[key].splice(index, 1);
              }
            });

            if (chapterName) {
              let uploadChapterIndex = this.ProfileDocument.chapters.findIndex(
                x => x.name === chapterName
              );
              // eslint-disable-next-line
              if (uploadChapterIndex > -1) {
                let sort = this.ProfileDocument.chapters[uploadChapterIndex]
                  .items.length;
                let newmItem = {
                  type: "Photo",
                  photo: newImage,
                  sort: sort,
                  _id: newImage._id
                };
                // eslint-disable-next-line
                if (
                  this.ProfileDocument.chapters[
                    uploadChapterIndex
                  ].items.findIndex(i => i.photo.id === newmItem.photo.id) ===
                  -1
                ) {
                  this.ProfileDocument.chapters[
                    uploadChapterIndex
                  ].items.push(newmItem);
                  this.ProfileDocument = this.ProfileDocument;

                  /* Sleep for 1.5 seconds */
                  await sleep(1500);

                  /* Update the ProfileDocument collection */
                  await this.updateProfileDocument("upload");
                  this.layout();
                }
              }
            } else {
              /* Check if the item is a special picture */
              let spacialPictures = [
                "Front Cover",
                "Back Cover",
                "Center Spread"
              ];
              let specialType = null;
              spacialPictures.forEach(async s => {
                specialType = "special_" + s.replace(" ", "").toLowerCase();
                if (
                  this.uploadData[specialType] &&
                  newImage.filename.indexOf(specialType) > -1
                ) {
                  let DBKey = s.replace(" ", "_").toLowerCase(); // front_cover, back_cover and center_spread
                  if (!this.ProfileDocument.special_pictures) {
                    this.ProfileDocument.special_pictures = {};
                  }
                  this.ProfileDocument.special_pictures[DBKey] = {
                    photo: newImage,
                    status: "Pending"
                  };
                  this.ProfileDocument = this.ProfileDocument;

                  /* Clear the file from uploadData */
                  delete this.uploadData[specialType];

                  /* Sleep for 1.5 seconds */
                  await sleep(1500);

                  /* Update the ProfileDocument collection */
                  await this.updateProfileDocument("upload");
                  this.setSpecialPictures();
                }
              });
            }
          }
        }
      }
    });
    // }
  },
  beforeRouteEnter(to, from, next) {
    if (!session.isOnline()) {
      next({ path: "/login" });
    } else {
      next();
    }
  },
  watch: {
    realCurrentContent: {
      handler: async function(newValue) {
        if (newValue) {
          await this.updateProfileDocument('content');
          this.enableContentSave = false;
        }
      }
    },
    currentRevisionContent (newValue) {
      if (newValue && newValue.trim()) {
        let wordCount = this.profileSettings.content_word_count || 250;
        this.remainingWords = wordCount - newValue.trim().split(/\s+/).length;
      }
    }
  },
  methods: {
    getOptions: function() {
      return {
        layoutMode: "masonry",
        masonry: {
          columnWidth: ".sm3",
          // gutter: 8
        },
        percentPosition: true,
        originLeft: true,
        itemSelector: ".chapter-item"
      };
    },
    scrollToTop () {
      /* Scroll to the top */
      window.getApp.$vuetify.goTo(document.getElementById('pageHeader').offsetTop - 70);
    },
    scrollToTabTop (elementId) {
      /* Scroll to the top */
      window.getApp.$vuetify.goTo(document.getElementById(elementId).offsetTop);
    },
    goToNextStep (step) {
      if (step) {
        this.tabsModel = `tab-${step}`;
        this.scrollToTabTop('top-tabs');
      }
    },
    layout() {
      let keys = Object.keys(this.groupedChapterPhotos);
      for (let date in this.groupedChapterPhotos) {
        let id = keys.indexOf(date);
        if (id > -1 && this.$refs['chapterImages_' + id]) {
          this.$refs['chapterImages_' + id][0].layout("masonry");
        }
      }
      // if (this.$refs.chapterImages) {
      //   this.$refs.chapterImages.layout("masonry");
      // }
    },
    layoutAllPhotos() {
      if (this.$refs.profileAlbumImages) {
        this.$refs.profileAlbumImages.layout("masonry");
      }
    },
    layoutQualityPhotos() {
      if (this.$refs.profileQualityImages) {
        this.$refs.profileQualityImages.layout("masonry");
      }
    },
    layoutAlbums() {
      if (this.$refs.albumList) {
        this.$refs.albumList.layout("masonry");
      }
    },
    changeCurrentDoc(e, i = -1) {
      let chapter = null;
      let chapterIndex = -1;
      if (i > -1) {
        chapter = this.ProfileDocument.chapters[i];
        chapterIndex = i;
      } else if (e.target && e.target.value) {
        let index = this.ProfileDocument.chapters.findIndex(
          x => x.name === e.target.value
        );
        if (index > -1) {
          chapter = this.ProfileDocument.chapters[index];
          chapterIndex = index;
        }
      }
      if (chapter && chapterIndex > -1) {
        this.viewChapter(chapter, chapterIndex);
      }
    },
    async loadProfileDocument() {
      if (this.documentId) {
        let entity = "ProfileDocument";
        let select =
          "filename mimetype size original_url thumb_url webview_url caption";
        let populate = [
          { path: "chapters.items.photo", select: select },
          { path: "writer", select: 'human' },
          { path: "special_pictures.front_cover.photo", select: select },
          { path: "special_pictures.back_cover.photo", select: select },
          { path: "special_pictures.center_spread.photo", select: select },
          { path: "account", select: "profile_album human avatar name account_type membership default_agency" },
          { path: "pdf.template", select: 'file' }
        ];
        let where = { _id: this.documentId };
        let { error, data } = await getCollection(
          entity,
          true,
          0,
          populate,
          where
        );
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.ProfileDocument = data[0];
            this.accountDetails = data[0].account || this.accountDetails;

            /* Filter out the items if not yet submitted */
            // let enabledStatuses = ['Review', 'Replace', 'Approved'];
            // if (this.ProfileDocument.chapters && this.ProfileDocument.chapters.length) {
            //   this.ProfileDocument.chapters = this.ProfileDocument.chapters.map(chapter => {
            //     if (chapter.items && chapter.items.length) {
            //       chapter.items = chapter.items.filter(item => item && enabledStatuses.indexOf(item.status) > -1);
            //     }
            //     return chapter;
            //   });
            // }

            /* Arrange based on sort value */
            if (
              this.ProfileDocument.chapters &&
              this.ProfileDocument.chapters.length
            ) {
              this.ProfileDocument.chapters.sort((a, b) => a.sort - b.sort);
              this.ProfileDocument = this.ProfileDocument;
            }

          } else {
            swal.fire({
              type: "warning",
              title: "Invalid Document",
              text: "The profile document was not found.",
              timer: 2500,
              onClose: () => {
                return;
              }
            });
            return;
          }
        }
      }
    },
    async loadProfileSettings() {
      let loaded = false;
      if (this.accountDetails.default_agency) {
        let { error, data } = await getOne('Agency', this.accountDetails.default_agency, '', 'profile_doc_settings');
        if (error) {
          console.log(error);
        } else {
          if (data && data.profile_doc_settings && Object.keys(data.profile_doc_settings)) {
            loaded = true;
            this.profileSettings = data.profile_doc_settings;
          }
        }
      }
      if (!loaded) {
        let { error, data } = await getCollection('Agency', true, 0, '', { is_super_admin: true }, 'profile_doc_settings');
        if (error) {
          console.log(error);
        } else {
          if (data.length && data[0].profile_doc_settings && Object.keys(data[0].profile_doc_settings).length) {
            this.profileSettings = data[0].profile_doc_settings;
          }
        }
      }

      if (!this.profileSettings.max_chapter_photos) {
        this.profileSettings.max_chapter_photos = 10;
      }
      if (!this.profileSettings.content_word_count) {
        this.profileSettings.content_word_count = 250;
      }
      this.remainingWords = this.profileSettings.content_word_count;
      if (!this.profileSettings.max_chapters) {
        this.profileSettings.max_chapters = 10;
      }
      if (typeof this.profileSettings.back_cover_required === 'undefined') {
        this.profileSettings.back_cover_required = true;
      }
      if (typeof this.profileSettings.agency_approval_required === 'undefined') {
        this.profileSettings.agency_approval_required = false;
      }
      if (typeof this.profileSettings.center_spread_required === 'undefined') {
        this.profileSettings.center_spread_required = true;
      }
      /* if (!this.profileSettings.tips_text) {
        this.profileSettings.tips_text = `<h5 class="mb-2 font-weight-bold">Here are some tips to complete your profile documents.</h5><p class="font-italic">The tips goes here</p>`;
      } */

    },
    async loadConversation (isCoverConversations = false) {

      if ((this.currentDocument && this.currentDocument._id && !this.ProfileDocConversation[this.currentDocument._id]) || (isCoverConversations && !this.ProfileDocConversation[this.ProfileDocument._id])) {
        // this.loadingMessages = true;
        let sort = { 'updatedAt': -1 };
        let sessionUser = session.getSession();
        let where = {};
        where = {
          $and: [
            {
              $or: [
                {
                  human: sessionUser.user.human.id
                }
              ]
            },
            {
              $or: [
                {
                  archive: { $exists: false }
                },
                {
                  archive: {
                    $ne: sessionUser.user.human.id
                  }
                }
              ]
            },
            {
              $or: [
                {
                  removed: { $exists: false }
                },
                {
                  removed: {
                    $ne: sessionUser.user.human.id
                  }
                }
              ]
            }
          ]
        };

        if (isCoverConversations) {
          where.$and.push({ profile_cover: this.ProfileDocument._id });
        } else {
          where.$and.push({ profile_chapter: this.currentDocument._id });
        }

        if (sessionUser.user.human.group && sessionUser.user.human.group.length) {
          where.$and[0].$or.push({
            groups: {
              $in: sessionUser.user.human.group && sessionUser.user.human.group.length ? sessionUser.user.human.group.map(group => group.group) : []
            }
          });
        }
        let { error, data } = await getCollection('Conversation', true, 0, await conversationListPopulate(sessionUser.user.human.id), where, null, null, sort, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            
            if (isCoverConversations) {
              this.ProfileDocConversation[this.ProfileDocument._id] = data[0];
            } else {
              this.ProfileDocConversation[this.currentDocument._id] = data[0];
            }

            setTimeout(() => {
              const container = this.$el.querySelector('.ps-container.messages-conversation');
              container.scrollTop = container.scrollHeight;
              this.loadingMessages = false;
            }, 0);
            
          } else {
            this.loadingMessages = false;
          }
        }
      }
    },
    async createConversation (isCoverImage = false) {
      /* Create if writer human id exists */
      let conversation = {
        human: []
      };
      if (((this.currentDocument && this.currentDocument._id) || isCoverImage) && this.ProfileDocument.account && this.ProfileDocument.account.human && this.ProfileDocument.account.human.length) {

        conversation.human.push(this.Agency.human[0]);
        conversation.human.push(this.ProfileDocument.account.human[0]);
        if (isCoverImage) {
          conversation.profile_cover = this.ProfileDocument._id;
          conversation.subject = `Profile Covers Comments`;
        } else {
          conversation.profile_chapter = this.currentDocument._id;
          conversation.subject = `Chapter Comments - ${this.currentDocument.name}`;
        }

        let { error, data, status } = await create('Conversation', conversation);
        if (error) {
          console.log('error', error);
        } else {
          if (isCoverImage) {
            this.ProfileDocConversation[this.ProfileDocument._id] = data;
          } else {
            this.ProfileDocConversation[this.currentDocument._id] = data;
          }
          return true;
        }
      }
      return false;
    },
    async send (isSilent = false) {
      let isCover = false;
      /* Create conversation if not exists */
      if (this.currentDocument && (!this.currentDocument._id || !this.ProfileDocConversation[this.currentDocument._id])) {
        if (!await this.createConversation() && !isSilent) {
          swal.fire({
            type: 'warning',
            title: 'Failed',
            text: 'Failed to initiate the conversation, please try again',
            showConfirmButton: true,
            onClose: () => {}
          });
          return;
        }
      } else if (this.tabsModel === 'tab-3') {
        isCover = true;
        if (!this.ProfileDocConversation[this.ProfileDocument._id]) {
          /* Create the conversation for profile covers - identifier as the profile doc id */
          if (!await this.createConversation(isCover) && !isSilent) {
            swal.fire({
              type: 'warning',
              title: 'Failed',
              text: 'Failed to initiate the conversation, please try again',
              showConfirmButton: true,
              onClose: () => {}
            });
            return;
          }
        }
      }

      if (this.message.content && (this.currentDocument || isCover)) {

        let conversationIdentifier = isCover ? this.ProfileDocument._id : this.currentDocument._id;
        let chapterConversation = this.ProfileDocConversation[conversationIdentifier];
        this.message.conversation = chapterConversation.id;
        this.message.sender = this.Agency.human[0];

        let { error, data, status } = await create('Message', this.message);
        if (error) {
          console.log('error', error);
        } else {

          let humanData = {
            agency: {
              avatar: this.Agency.avatar,
              id: this.Agency.id,
              name: this.Agency.name,
              _id: this.Agency._id
            },
            birth_date: this.Agency.human[0].birth_date,
            id: this.Agency.human[0].id,
            user: this.Agency.human[0].user,
            _id: this.Agency.human[0]._id,
          };

          data.human = humanData;
          
          /* Update the state */
          if (!this.ProfileDocConversation[conversationIdentifier].message) {
            this.ProfileDocConversation[conversationIdentifier].message = [];
          }
          this.ProfileDocConversation[conversationIdentifier].message.push({ message: data });
          this.ProfileDocConversation[conversationIdentifier].last_message = data;
          this.message.content = '';

          if (!isSilent) {
            // swal.fire({
            //   type: 'success',
            //   title: 'Message sent successfully',
            //   timer: 2500,
            //   onClose: () => {
            //   }
            // });
          
            setTimeout(() => {
              const container = this.$el.querySelector('.ps-container.messages-conversation');
              container.scrollTop = container.scrollHeight;
            }, 0);

          }

        }
      }
    },
    setSpecialPictures() {
      if (
        Object.keys(this.ProfileDocument).length &&
        this.ProfileDocument.special_pictures
      ) {
        this.front_cover =
          this.ProfileDocument.special_pictures["front_cover"] &&
          this.ProfileDocument.special_pictures["front_cover"].photo &&
          this.ProfileDocument.special_pictures["front_cover"].photo
            .original_url
            ? (this.ProfileDocument.special_pictures[
                "front_cover"
              ].photo.original_url.indexOf("http") === -1
                ? config.s3BucketPath
                : "") +
              this.ProfileDocument.special_pictures["front_cover"].photo
                .original_url
            : this.front_cover;

        this.back_cover =
          this.ProfileDocument.special_pictures["back_cover"] &&
          this.ProfileDocument.special_pictures["back_cover"].photo &&
          this.ProfileDocument.special_pictures["back_cover"].photo.original_url
            ? (this.ProfileDocument.special_pictures[
                "back_cover"
              ].photo.original_url.indexOf("http") === -1
                ? config.s3BucketPath
                : "") +
              this.ProfileDocument.special_pictures["back_cover"].photo
                .original_url
            : this.back_cover;

        this.center_spread =
          this.ProfileDocument.special_pictures["center_spread"] &&
          this.ProfileDocument.special_pictures["center_spread"].photo &&
          this.ProfileDocument.special_pictures["center_spread"].photo
            .original_url
            ? (this.ProfileDocument.special_pictures[
                "center_spread"
              ].photo.original_url.indexOf("http") === -1
                ? config.s3BucketPath
                : "") +
              this.ProfileDocument.special_pictures["center_spread"].photo
                .original_url
            : this.center_spread;
      }
    },
    getSpecialPicture(key) {
      if (this[key]) {
        return this[key];
      }
      return null;
    },
    async loadAlbums () {
      if (!this.albumList.length && this.ProfileDocument && this.ProfileDocument.account && this.ProfileDocument.account.id) {
        let sessionUser = session.getSession();
        let where = {
          account: this.ProfileDocument.account.id
        };
        let populate = { path: 'photo.photo', select: 'filename mimetype size original_url thumb_url webview_url caption' };
        let { error, data } = await getCollection('Album', true, 0, populate, where);
        if (error) {
          console.log('error', error);
        } else {
          if (data.length > 0) {
            this.albumList = sortList('Album', data, 'Account', sessionUser.adminUser ? sessionUser.user.human.account.id : 'Me');
            await this.setUnassignedItems();
          }
        }
      }
    },
    async loadProfileAlbum() {
      if (
        this.ProfileDocument &&
        this.ProfileDocument.account &&
        this.ProfileDocument.account.profile_album
      ) {
        let { error, data } = await getOne(
          "Album",
          this.ProfileDocument.account.profile_album
        );
        if (error) {
          console.log(error);
        } else {
          if (data) {
            this.profileAlbum = data;
          } else {
            await this.createProfileAlbum();
          }
        }
      } else {
        swal.fire({
          type: "warning",
          title: "Error",
          text: "The profile album for the account was not found",
          showConfirmButton: true,
          onClose: () => {}
        });
        return;
      }
    },

    async selectPhoto(photo, toAdd = false) {
      /* Return if not yet submitted */
      if (!photo || this.ProfileDocument.submitted || (toAdd && (this.isAlreadyAssigned(photo) /* || this.isLowQualityImage(photo) */))) {
        return;
      }
      /* 
        1. If selected from the photo list to add, add photo and auto save
        2. If selected from the existing list in photo add screen, remove photo and auto save
        3. If selected from the existing photos only screen, select multiple and proceed with the events
      */
      /* Add the photo to the currentDocument */
      let autoSave = false;
      if (toAdd) {
        autoSave = true;
        if (this.currentDocument.items && this.currentDocument.items.length >= this.profileSettings.max_chapter_photos) {
          swal.fire({
            type: 'warning',
            title: 'Limit Exceeded',
            text: `You can add only up to ${ this.profileSettings.max_chapter_photos } photos`,
            showConfirmButton: true,
            onClose: () => {}
          });
          return;
        }
        photo.status = 'Saved';
        this.currentDocument.items.push(photo);
      } else if (this.addingPhotos) {
        let index = this.currentDocument.items.findIndex(x => x.photo.id.toString() === photo.photo.id.toString());
        if (index > -1) {
          this.currentDocument.items.splice(index, 1);
          autoSave = true;
        }
      } else {
        /* Case #3 */
        if (photo && photo._id &&
          this.selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1) {
          this.selectedPhotos.splice(
            this.selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()),
            1
          );
        } else {
          this.selectedPhotos.push(photo);
        }
      }
      if (autoSave) {
        this.currentDocument = this.currentDocument;
        this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
        await this.updateProfileDocument('addPhoto');
        this.setUnassignedItems();
      }
      /* if (
        photo &&
        photo._id &&
        this.selectedPhotos.findIndex(
          x => x._id.toString() === photo._id.toString()
        ) > -1
      ) {
        this.selectedPhotos.splice(
          this.selectedPhotos.findIndex(
            x => x._id.toString() === photo._id.toString()
          ),
          1
        );
      } else {
        this.selectedPhotos.push(photo);
      } */
    },
    async removePhoto(photo) {
      if (!photo || photo.status === 'Approved' || this.ProfileDocument.submitted) {
        return;
      }
      
      let index = this.currentDocument.items.findIndex(x => x.photo.id.toString() === photo.photo.id.toString());
      if (index > -1) {
        this.currentDocument.items.splice(index, 1);
      }
      
      this.currentDocument = this.currentDocument;
      this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
      await this.updateProfileDocument('unassign');
      this.setUnassignedItems();

    },
    getCoverImage (photo, type = 'webview_url') {
      if (!photo || !type) {
        return;
      }
      if (photo[type]) {
        return `${photo[type].indexOf('http') === -1 ? config.s3BucketPath : '' }${photo[type]}`;
      }
      return false;
    },
    viewCoverPhoto(photo) {
      /* Return if no photo */
      if (!photo || !this.ProfileDocument.special_pictures || !this.ProfileDocument.special_pictures[photo.key]) {
        return;
      }
      this.currentCoverPhoto = this.ProfileDocument.special_pictures[photo.key];
      this.coverPhotoType = photo.key;
      this.isCoverPhotoView = true;

      /* Set the photo dimensions */
      this.setPhotoDimensions(photo);
    },
    closeViewCoverPhoto () {
      this.currentCoverPhoto = null;
      this.currentPhotoDim = null;
      this.coverPhotoType = null;
      this.isCoverPhotoView = false;
    },
    viewPhoto(photo, index) {
      /* Return if no photo */
      if (!photo || index === -1) {
        return;
      }
      this.currentPhoto = photo;
      this.currentPhotoIndex = index;
      this.isPhotoView = true;

      /* Set the photo dimensions */
      this.setPhotoDimensions(photo);

    },
    setPhotoDimensions (photo) {
      photo = photo.photo || null;
      let self = this;
      if (photo && photo.original_url) {
        let img = new Image();
        img.src = photo.original_url;
        img.onload = function () {
          self.currentPhotoDim = `${img.width}x${img.height}`;
        };
      }
    },
    closeViewPhoto () {
      this.currentPhoto = null;
      this.currentPhotoDim = null;
      this.currentPhotoIndex = -1;
      this.isPhotoView = false;
    },
    changeCurrentPhoto (type) {
      if (!type) {
        return;
      }
      /* Return if last photo and click next, and first photo and click back */
      if ((type === 'back' && this.currentPhotoIndex === 0) || (type === 'next' && this.currentPhotoIndex === this.currentDocument.items.length - 1)) {
        return;
      }
      switch (type) {
        case 'back':
          this.currentPhotoIndex -= 1;
          this.currentPhoto = this.currentDocument.items[this.currentPhotoIndex];
          break;
        case 'next':
          this.currentPhotoIndex += 1;
          this.currentPhoto = this.currentDocument.items[this.currentPhotoIndex];
          break;
        default:
          break;
      }
    },
    closeAddPhotos() {
      this.selectedPhotos = [];
      this.addingPhotos = false;

      this.currentAlbum = null;
      this.currentAlbumIndex = -1;
      
      /* Trigger window resize to re-arrange the photos */
      window.dispatchEvent(new Event('resize'));
      
    },
    /* whereAmI () {
      this.showStatusPopup = true;
    }, */
    async initializeHelpVideos() {
      if (!this.helpVideoList.length) {
        if (typeof this.accountDetails.membership !== "undefined") {
          let where = {
            membership: this.accountDetails.membership,
            category: "Profile Document"
          };
          let sort = { sort_no: 1 };
          let { error, data } = await getCollection(
            "HelpVideo",
            true,
            0,
            "",
            where,
            null,
            null,
            sort
          );
          if (error) {
            console.log(error);
          } else {
            if (data.length > 0) {
              /* Set the first one as the currentHelpVideo */
              this.currentHelpVideo = data[0];

              /* Fetch the vimeo thumbnails for each video */
              let videoJSON = null;
              let videoId = null;
              let video = null;
              for (let i = 0; i < data.length; i++) {
                video = data[i];
                videoId = video.url.substr(video.url.lastIndexOf("/") + 1);
                videoJSON = await getVimeoJSON(videoId);
                video.thumbnail =
                  videoJSON.data &&
                  videoJSON.data[0] &&
                  videoJSON.data[0].thumbnail_small
                    ? videoJSON.data[0].thumbnail_small
                    : null;
                data[i] = video;
              }
              this.helpVideoList = data;
            }
          }
        }
      }
    },
    viewHelpVideo(video) {
      this.currentHelpVideo = video;
    },
    viewHelp() {
      this.currentDocument = null;
      this.currentDocumentIndex = -1;
    },
    backToListing() {
      this.closeAddPhotos();
      /* Show the main tabs */
      this.topTabsDisplay = 'block';
      this.currentDocument = null;
      this.currentDocumentIndex = -1;

      /* Hide the tips and comments */
      this.showComments = this.showTips = false;

      /* Unset the current revision content */
      this.currentRevisionContent = '';

      /* Unset isWordsExceeded */
      this.isWordsExceeded = false;
    },

    getChapterStatus(doc) {
      let statuses = [];
      if (doc) {
        if (doc.content && doc.content.status) {
          statuses.push(doc.content.status);
        } else {
          statuses.push("Pending");
        }
        if (doc.items && doc.items.length) {
          doc.items.forEach(photo => {
            if (photo && photo.status) {
              statuses.push(photo.status);
            }
          });
        } else {
          statuses.push("Pending");
        }
        if (statuses.length) {
          if (statuses.indexOf("AgencyReview") > -1) {
            return "AgencyReview";
          } else if (statuses.indexOf("Review") > -1) {
            return "Review";
          } else if (statuses.indexOf("WriterReview") > -1) {
            return "WriterReview";
          } else if (statuses.indexOf("Pending") > -1) {
            return "Pending";
          } else if (statuses.indexOf("Saved") > -1) {
            return "Saved";
          } else if (statuses.indexOf("Suggestion") > -1) {
            return "Suggestion";
          } else if (statuses.indexOf("AgencySuggestion") > -1) {
            return "AgencySuggestion";
          } else if (statuses.indexOf("Replace") > -1) {
            return "Replace";
          } else if (
            statuses.filter(x => x === "Approved").length === statuses.length &&
            statuses.length === doc.items.length + 1
          ) {
            return "Approved";
          } else {
            return "Pending";
          }
        }
      }
      return "Pending";
    },
    setNewContent (isWriterReview = false) {
      if (this.currentRevisionContent) {
        this.currentDocument.content.revision[
          this.currentDocument.content.revision.length - 1
        ].text = this.currentRevisionContent;
        /* Set the content date Add the content to the payload */
        this.currentDocument.content.status = isWriterReview ? 'WriterReview' : 'AgencySuggestion';
        this.currentDocument.content.status_date = new Date().toISOString();
        if (!isWriterReview) {
            this.currentDocument.content.agency = this.Agency.id;
        }
        this.ProfileDocument.chapters[
          this.currentDocumentIndex
        ] = this.currentDocument;
      }
    },
    async updateProfileDocument(requestFrom = "manual", writerStatus = null, writerSuggestion = null, isWriterReview = false) {
      if (requestFrom === "content") {
        if (
          !this.currentRevisionContent ||
          !this.currentRevisionContent
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/\s/g, "").length
        ) {
          swal.fire({
            type: "warning",
            title: "Empty Content",
            text: "Please add the chapter content to save",
            showConfirmButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK"
          });
          return;
        } else {
          this.setNewContent(isWriterReview);
        }
      } else if (requestFrom === "downloadZIP") {
        if (!this.ProfileDocument.zip_downloaded) {
          this.ProfileDocument.zip_downloaded = (new Date()).toISOString();
        } else {
          return;
        }
      }

      let entity = "ProfileDocument";

      /* Remove dummy chapters */
      this.ProfileDocument.chapters = this.ProfileDocument.chapters.filter(
        x => x.name
      );
      this.setDocumentStatuses();
      let updateData = JSON.parse(JSON.stringify(this.ProfileDocument));
      updateData = await this.formatProfileDocument(updateData);

      let isSubmit = false;
      let statusByWriter = false;
      let submitMessages = {};
      if (
        ["submitContent", "submitPhotos", "submitCover"].indexOf(requestFrom) >
        -1
      ) {
        isSubmit = true;
        submitMessages = {
          submitContent: "chapter content was",
          submitPhotos: "chapter photos were",
          submitCover: "cover pictures were"
        };
        updateData.submit_type = requestFrom;
      } else if (
        ["contentStatus", "photosStatus", "coverStatus"].indexOf(requestFrom) >
        -1
      ) {
        statusByWriter = true;
        updateData.submit_type = requestFrom;
        updateData.status_type = writerStatus;
        updateData.suggestion = writerSuggestion;
      }
      if (requestFrom && ['uploadPDF', 'pdfStatusWriter'].indexOf(requestFrom) > -1) {
        updateData.request_from = requestFrom;
      }

      let { error, data } = await update(entity, updateData, updateData.id);
      if (error) {
        console.log(error);
      } else {
        if (requestFrom === 'uploadPDF') {
          if (data.pdf && data.pdf.review_conversation && !this.ProfileDocument.pdf.review_conversation) {
            this.ProfileDocument.pdf.review_conversation = data.pdf.review_conversation;
          }
          if (data.pdf && data.pdf.approval_conversation && !this.ProfileDocument.pdf.approval_conversation) {
            this.ProfileDocument.pdf.approval_conversation = data.pdf.approval_conversation;
          }
        }

        if (isWriterReview) {
          this.enableContentSave = false;
        }
        /* Success message only for selected times */
        /* if (["content", "manual"].indexOf(requestFrom) > -1) {
          swal.fire({
            type: "success",
            title: "Updated",
            text: "The profile document was updated.",
            timer: 2500
          });
        } else  */if (isSubmit) {
          /* swal.fire({
            type: "success",
            title: "Submitted",
            text: `The ${submitMessages[requestFrom]} successfully submitted, you'll be notified when it's done`,
            timer: 2500
          }); */
          this.backToListing();
        }/*  else if (statusByWriter) {
          let messages = {
            contentStatusApproved: "The chapter content has been approved",
            contentStatusReplace: "The parent was asked for content replacement successfully",
            photosStatusApproved: "The photo has been approved",
            photosStatusReplace: "The parent was asked for photo replacement successfully",
            coverStatusApprove: "The cover page has been approved",
            coverStatusReplace: "The parent was asked for cover photo replacement successfully"
          };
          swal.fire({
            type: "success",
            title: "Success",
            text: messages[`${requestFrom}${writerStatus}`],
            timer: 2500,
          });
        } else if (["callout", "note"].indexOf(requestFrom) > -1 ) {
          swal.fire({
            type: "success",
            title: "Success",
            text: `The ${requestFrom} was successfully added`,
            timer: 2500,
          });
        } */
        /* Update the chapter schema id if new chapter was added */
        if (requestFrom === 'newChapter') {
          this.ProfileDocument.chapters[this.ProfileDocument.chapters.length - 1]._id = data.chapters[data.chapters.length - 1]._id;
          this.ProfileDocument = this.ProfileDocument;
        }
        return { error, data };
      }
    },
    async formatProfileDocument(data) {
      data.chapters = data.chapters.map(c => {
        c.items = c.items
          .filter(i => i.photo && i.photo.id)
          .map(i => {
            i.photo = i.photo.id;
            return i;
          });
        /* Set the content as object - init */
        if (c.content) {
          if (typeof c.content === "string") {
            c.content = {
              revision: [{ text: c.content, owner: "Parent", date: (new Date()).toISOString() }],
              status: "Saved"
            };
          }

          if (c.content && c.content.revision && c.content.revision.length) {
            /* Remove the revision if no text found */
            c.content.revision = c.content.revision.filter(rev => {
              return rev.text && rev.text.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length;
            });
          }

          let content =
            c.content &&
            c.content.revision &&
            c.content.revision.length &&
            c.content.revision[c.content.revision.length - 1].text
              ? c.content.revision[c.content.revision.length - 1].text
              : null;

          /* Change to saved if all done */
          if (
            content &&
            content.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length &&
            c.content.status === "Pending"
          ) {
            c.content.status = "Suggestion";
          }
        }
        return c;
      });
      /* Change the populated objects to IDs in special_pictures */
      if (data.special_pictures) {
        let specialKeys = Object.keys(data.special_pictures);
        if (specialKeys.length) {
          specialKeys.forEach(key => {
            if (
              data.special_pictures[key] &&
              data.special_pictures[key].photo
            ) {
              data.special_pictures[key].photo =
                data.special_pictures[key].photo.id;
            }
          });
        }
      }
      if (data.account && data.account.id) {
        data.account = data.account.id;
      }
      if (data.pdf && data.pdf.template && data.pdf.template.id) {
        data.pdf.template = data.pdf.template.id;
      }
      return data;
    },
    async setDocumentStatuses() {
      let data = JSON.parse(JSON.stringify(this.ProfileDocument));
      data.chapters = data.chapters.map(c => {
        /* Photos */
        c.items = c.items.map(i => {
          if (!i.status || i.status === "Pending") {
            i.status = "Saved";
          }
          return i;
        });

        /* Set the content as object - initial content always by parent */
        if (!c.content) {
          c.content = {
            revision: [{ text: "", owner: "Parent", date: (new Date()).toISOString() }],
            status: "Pending"
          };
        }

        let content =
          c.content &&
          c.content.revision &&
          c.content.revision.length &&
          c.content.revision[c.content.revision.length - 1].text
            ? c.content.revision[c.content.revision.length - 1].text
            : null;

        if (
          content &&
          content.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length &&
          c.content.status === "Pending"
        ) {
          c.content.status = "Suggestion";
        } else if (
          !content ||
          (!content.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length &&
            c.content.status !== "Pending")
        ) {
          c.content.status = "Pending";
        }
        return c;
      });

      if (data.special_pictures && Object.keys(data.special_pictures).length) {
        if (
          data.special_pictures.front_cover &&
          data.special_pictures.front_cover.photo &&
          data.special_pictures.front_cover.status === "Pending"
        ) {
          data.special_pictures.front_cover.status = "Saved";
        }
        if (
          data.special_pictures.center_spread &&
          data.special_pictures.center_spread.photo &&
          data.special_pictures.center_spread.status === "Pending"
        ) {
          data.special_pictures.center_spread.status = "Saved";
        }
        if (
          data.special_pictures.back_cover &&
          data.special_pictures.back_cover.photo &&
          data.special_pictures.back_cover.status === "Pending"
        ) {
          data.special_pictures.back_cover.status = "Saved";
        }
      }

      this.ProfileDocument = data;

      // if (this.currentDocumentIndex > -1 && this.currentDocument) {
      //   this.viewChapter(
      //     this.ProfileDocument.chapters[this.currentDocumentIndex],
      //     this.currentDocumentIndex
      //   );
      // }
    },
    async addChapter() {

      if (this.ProfileDocument.submitted) {
        return;
      }

      if (this.ProfileDocument.chapters.length >= (this.profileSettings.max_chapters || 10)) {
        swal.fire({
          type: 'warning',
          title: 'Limit Exceeded',
          text: `You can only add maximum of ${ this.profileSettings.max_chapters || 10 } chapters`,
          showConfirmButton: true,
          onClose: () => {}
        });
        return;
      }

      const { value: chapterName } = await swal.fire({
        title: "Enter the chapter name",
        input: "text",
        inputValue: "",
        showCancelButton: true,
        inputValidator: value => {
          if (!value) {
            return "You need to enter the chapter name";
          }
        }
      });

      if (chapterName) {

        let newContent = this.profileSettings.default_content && this.profileSettings.default_content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length ? this.profileSettings.default_content : null;

        let newChapter = {
          name: chapterName,
          items: [],
          sort: this.ProfileDocument.chapters.length
        };
        if (newContent) {
          newChapter.content = { revision: [{ text: newContent, owner: 'Parent', date: (new Date()).toISOString() }], status: 'Saved', status_date: (new Date()).toISOString() };
        }
        this.ProfileDocument.chapters.push(newChapter);
        this.updateProfileDocument('newChapter');

        /* Open the chapter and enable the title edit */
        this.viewChapter(newChapter, this.ProfileDocument.chapters.length - 1);
        this.scrollToTop();
      }
    },
    contentChanged(event, editor) {
      if (
        this.currentRevisionContent &&
        this.currentRevisionContent
          .replace(/(<([^>]+)>)/gi, "")
          .replace(/\s/g, "").length
      ) {
        let wordCount = this.profileSettings.content_word_count || 250;
        if (editor && editor.plugins && editor.plugins.wordcount && editor.plugins.wordcount.body.getWordCount() > wordCount) {
          this.remainingWords = wordCount - editor.plugins.wordcount.body.getWordCount();
          this.isWordsExceeded = true;
          this.enableContentSave = false;
          return;
        } else {
          this.remainingWords = wordCount - editor.plugins.wordcount.body.getWordCount();
          this.isWordsExceeded = false;
          this.enableContentSave = true;
          this.isContentSubmitted = false;
          this.realCurrentContent = this.currentRevisionContent;
        }
      }
    },
    viewChapter(chapter, chapterIndex, isSpecific = false) {
      /* Reset the panels */
      this.closeAddPhotos();

      /* Hide the tips and comments */
      this.showComments = this.showTips = false;

      /* Set the default tab as content */
      if (!isSpecific) {
        this.chapterTabs = 'tab-1'; // Content
      }

      /* Set the currentDocument */
      this.currentDocument = chapter;
      this.currentDocumentIndex = chapterIndex;

      /* Set the currentTipsText */
      this.setCurrentTipsText();

      /* Scroll to the top */
      this.scrollToTabTop('chapter-content-tabs');

      /* Hide the main tabs */
      this.topTabsDisplay = 'none';

      if (
        this.currentDocument.content &&
        this.currentDocument.content.revision &&
        this.currentDocument.content.revision.length
      ) {
        let revisionLength = this.currentDocument.content.revision.length;
        this.currentRevisionContent =
          this.currentDocument.content.revision[revisionLength - 1] &&
          this.currentDocument.content.revision[revisionLength - 1].text
            ? this.currentDocument.content.revision[revisionLength - 1].text
            : '';
      } else {
        this.currentDocument.content = {
          revision: [{ text: "", owner: "Parent", date: (new Date()).toISOString() }],
          status: "Pending"
        };
        this.currentRevisionContent = '';
      }

      /* Load the chapter conversations */
      this.loadConversation();

      this.enableContentSave = false;

      // /* Set the unassigned items */
      // this.setUnassignedItems();

      /* Reset the selectedPhotos */
      this.selectedPhotos = [];

      /* Set the active content revision */
      if (this.currentDocument.content && this.currentDocument.content.revision && this.currentDocument.content.revision.length) {
        this.contentsModel = `tab-${this.currentDocument.content.revision.length}`;
      }

    },

    setCurrentTipsText () {
      if (!this.profileSettings || !this.profileSettings.default_chapters) {
        return;
      }
      let currChapterName = this.currentDocument.name;
      let defaultChapterIndex = this.profileSettings.default_chapters.findIndex(x => x.name === currChapterName);
      if (defaultChapterIndex > -1) {
        if (this.profileSettings.default_chapters[defaultChapterIndex] && this.profileSettings.default_chapters[defaultChapterIndex].tips) {
          this.currentTipsText = this.profileSettings.default_chapters[defaultChapterIndex].tips;
        }
      } else {
        currChapterName = currChapterName === 'About Me' ? 'About Us' : currChapterName;
        currChapterName = currChapterName === 'My Home' ? 'Our Home' : currChapterName;
        currChapterName = currChapterName === `About ${this.accountDetails.name.split(' / ')[0]}` ? 'About Parent 1' : currChapterName;
        currChapterName = this.accountDetails.account_type === 'Couple' && this.accountDetails.name.split(' / ')[1] && currChapterName === `About ${this.accountDetails.name.split(' / ')[1]}` ? 'About Parent 2' : currChapterName;
        defaultChapterIndex = this.profileSettings.default_chapters.findIndex(x => x.name === currChapterName);
        if (defaultChapterIndex > -1 && this.profileSettings.default_chapters[defaultChapterIndex] && this.profileSettings.default_chapters[defaultChapterIndex].tips) {
          this.currentTipsText = this.profileSettings.default_chapters[defaultChapterIndex].tips;
        } else if (this.profileSettings.tips_text && this.profileSettings.tips_text.new_chapters) {
          this.currentTipsText = this.profileSettings.tips_text.new_chapters;
        }
      }
    },

    selectPhotos(chapter = null, chapterIndex = -1, fromListing = false) {
      if (chapter && chapterIndex > -1) {
        this.viewChapter(chapter, chapterIndex);
        this.chapterTabs = 'tab-2'; // Photos
      }
window.getApp.$vuetify.goTo(document.getElementById('pageHeader').offsetTop - 70);
      /* Hide the tips and comments */
      this.showComments = this.showTips = false;

      /* Set the unassigned items */
      this.setUnassignedItems();

      this.selectedPhotos = [];

      if (!fromListing || !this.currentDocument.items || !this.currentDocument.items.length) {
        this.addingPhotos = true;
      }

      /* Trigger window resize to re-arrange the photos */
      window.dispatchEvent(new Event('resize'));
    },
    async sortChapters() {
      this.ProfileDocument.chapters = this.ProfileDocument.chapters.map(
        (chapter, i) => {
          chapter.sort = i;
          return chapter;
        }
      );
      this.ProfileDocument = this.ProfileDocument;
      /* Update the DB */
      await this.updateProfileDocument();
    },
    async sortChapterItems() {
      this.currentDocument.items = this.currentDocument.items.map((item, i) => {
        item.sort = i;
        return item;
      });
      this.ProfileDocument.chapters[
        this.currentDocumentIndex
      ] = this.currentDocument;
      this.ProfileDocument = this.ProfileDocument;
      /* Update the DB */
      await this.updateProfileDocument();
    },
    addImage(uploadTo = "chapter", type = null) {
      const client = global.filestack.init(this.config.filestack.client);
      const humanId = session.user().human.id;
      let albumId = this.accountDetails.profile_album
        ? this.accountDetails.profile_album
        : null;
      let specialType = type
        ? "special_" + type.replace(" ", "").toLowerCase()
        : null;
      if (!albumId) {
        swal.fire({
          title: "Album not found",
          text: "The profile album is not found, please check with your agency",
          type: "warning"
        });
        return;
      }
      const options = {
        fromSources: ["local_file_system"],
        maxFiles: 20,
        accept: ["image/jpeg", "image/jpg", "image/png", "image/gif"],
        uploadInBackground: false,
        storeTo: {
          location: "S3",
          path:
            "/" +
            this.config.s3Domain +
            "/" +
            humanId +
            "/album/" +
            albumId +
            "/original/",
          access: "public"
        },
        onFileSelected(file) {
          if (file.size < config.imageQuality) {
            swal.fire({
              type: 'warning',
              title: 'Too Small',
              text: `File(s) too small, photos should have a minimum size of ${(config.imageQuality / 1024 / 1024)} MB`,
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {}
            });
            throw new Error( `File(s) too small, photos should have a minimum size of ${(config.imageQuality / 1024 / 1024)} MB`);
          }
          let filenameArr = file.filename.split(".");
          let ext = filenameArr.pop();
          let filename = filenameArr.join(".");
          filename = filename.replace(/[^0-9a-z]/gi, "");
          filename = specialType ? filename + "_" + specialType : filename;
          return { name: filename + "_" + new Date().getTime() + "." + ext };
        },
        onFileUploadFinished: response => {
          let filename = response.key.substr(response.key.lastIndexOf("/") + 1);
          if (uploadTo === "special" && specialType) {
            this.uploadData[specialType] = filename;
          } else {
            if (this.uploadData[this.currentDocument.name]) {
              this.uploadData[this.currentDocument.name].push(filename);
            } else {
              this.uploadData[this.currentDocument.name] = [filename];
            }
          }
          this.closeAddPhotos();
        }
        /* onUploadDone: (response) => {
          let filename = null;
          response.filesUploaded.forEach(f => {
            filename = f.key.substr(f.key.lastIndexOf('/') + 1);
            if (uploadTo === 'special' && specialType) {

              this.uploadData[specialType] = filename;
              
            } else {
              if (this.uploadData[this.currentDocument.name]) {
                this.uploadData[this.currentDocument.name].push(filename);
              } else {
                this.uploadData[this.currentDocument.name] = [filename];
              }
            }
          });
        } */
      };
      if (uploadTo === "special") {
        options.maxFiles = 1;
        if (type === "Center Spread") {
          options.transformations = {
            crop: { aspectRatio: 1152 / 720, force: true }
          };
          // options.imageMin = [1152, 720];
          // options.imageMax = [1152, 720];
        } else {
          options.transformations = {
            crop: { aspectRatio: 576 / 720, force: true }
          };
          // options.imageMin = [576, 720];
          // options.imageMax = [576, 720];
        }
      }
      client.picker(options).open();
    },
    async uploadPDF (files) {
      
      if (!files) {
        return;
      }

      if (files.type !== 'application/pdf') {
        swal.fire({
          title: `<strong>Upload Error</strong>`,
          type: 'error',
          html: 'Please choose a PDF file',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      } else if (files.size > this.config.uploadFileSize) {
        swal.fire({
          title: `<strong>Upload Error</strong>`,
          type: 'error',
          html: 'Maximum file upload size is ' + (this.config.uploadFileSize / 1024 / 1024) + ' MB',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Close',
        });
        return;
      }
      ///
      
      if (files) {
        if (files.name.lastIndexOf('.') <= 0) {
          return;
        }
        
        window.getApp.$emit('AppProgress', true);
        const fr = new FileReader();
        fr.readAsDataURL(files);
        fr.addEventListener('load', async () => {

          window.getApp.$emit('BGProgress', false);

          let postUrl = 'PdfTemplate';
          let extraParams = {
            name: files.name,
            account: this.accountDetails.id,
            directory: '',
            is_active: false,
            request_from: 'ProfileDocument',
            agency: this.accountDetails.default_agency
          };
          let response = await uploadFile(postUrl, files, 'POST', extraParams);
          if (!response.$data) {
            window.getApp.$emit('AppProgress', false);
            console.log('error', response.$error);
            this.snackbar = {
              show: true,
              color: 'red',
              text: response.$error
            };
          } else {
            // Create the timeline
            let timelineData = {
              title: 'Profile PDF Uploaded',
              text: `The writer uploaded a profile PDF`
            };
            timelineData.account = this.accountDetails.id;

            let { error, data, status } = await create('Timeline', timelineData);
            if (error) {
              console.log('error', error);
              this.snackbar = {
                show: true,
                color: 'orange',
                text: 'Failed to create the timeline'
              };
            }

            /* Update the ProfileDocument with the PDF status */
            if (response.$data && response.$data.id) {

              if (!this.ProfileDocument.pdf) {
                this.ProfileDocument.pdf = {};
              }
              this.ProfileDocument.pdf.template = response.$data;
              if (!this.ProfileDocument.pdf.review_history) {
                this.ProfileDocument.pdf.review_history = [];
              }
              this.ProfileDocument.pdf.review_history.push({
                status: 'WriterReview',
                status_date: (new Date()).toISOString()
              });

              await this.updateProfileDocument('uploadPDF');
            }

            /* Clear the selection */
            this.$refs.uploadButton.clear();
            
            swal.fire({
              type: 'success',
              title: 'File uploaded successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                window.getApp.$emit('AppProgress', false);
              }
            });

          }
          window.getApp.$emit('BGProgress', true);
        });
      }

    },
    viewPDFSuggestions () {
      this.isViewPDFSuggestions = true;
    },
    closePDFSuggestions () {
      this.isViewPDFSuggestions = false;
    },
    // editChapterName (chapter) {
    //   this.editChapterIndex = this.ProfileDocument.chapters.findIndex(x => x.name === chapter.name);
    //   this.isChapterEdit = true;
    // },
    editItemCaption(item) {
      // this.editItemCaptionIndex = this.showUnassigned && this.unassignedItems.length ? this.unassignedItems.findIndex(x => x.photo.id === item.photo.id) : this.currentDocument.items.findIndex(x => x.photo.id === item.photo.id);
      this.isItemCaptionEdit = true;
    },
    deleteChapter(chapter) {
      swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(async result => {
          if (result.value) {
            this.ProfileDocument.chapters = this.ProfileDocument.chapters.filter(
              x => x.name !== chapter.name
            );
            await this.updateProfileDocument();
            return;
          }
        });
    },
    removePhotoCaptionEdit() {
      this.currentEditPhotoIndex = -1;
      this.currentEditPhoto = null;
      this.isEdit = false;
      this.editPhotoItem = null;
    },
    async unAssignSelectedPhotos() {
      this.selectedPhotos.forEach(item => {
        let itemIndex = this.currentDocument.items.findIndex(
          x => x._id.toString() === item._id.toString()
        );
        if (itemIndex > -1) {
          this.currentDocument.items.splice(itemIndex, 1);
        }
      });
      /* Reset the selestedPhotos */
      this.selectedPhotos = [];

      /* Set the ProfileDocument */
      this.ProfileDocument.chapters[
        this.currentDocumentIndex
      ] = this.currentDocument;
      this.ProfileDocument = this.ProfileDocument;
      /* Update the DB */
      await this.updateProfileDocument("unassign");
    },
    
    async assignSelectedPhotos() {
      if (this.selectedPhotos.length) {
        let newCount = this.selectedPhotos.length + (this.currentDocument.items ? this.currentDocument.items.length : 0);
        if (newCount > this.profileSettings.max_chapter_photos) {
          swal.fire({
            type: 'warning',
            title: 'Limit Exceeded',
            text: `You can add only up to ${ this.profileSettings.max_chapter_photos } photos`,
            showConfirmButton: true,
            onClose: () => {}
          });
          return;
        }
        this.currentDocument.items = [
          ...this.currentDocument.items,
          ...this.selectedPhotos
        ];
      }

      /* Set the ProfileDocument */
      this.ProfileDocument.chapters[
        this.currentDocumentIndex
      ] = this.currentDocument;
      this.ProfileDocument = this.ProfileDocument;

      this.selectedPhotos = [];

      /* Switch back to the album listing tab */
      if (this.currentAlbum) {
        this.backFromPhotos();
      }

      /* Update the DB */
      await this.updateProfileDocument();

      /* Update the unassigned items */
      await this.setUnassignedItems();
    },
    async setUnassignedItems() {
      
      let assignedPhotoIds = [];
      this.unassignedItems = [];
      
      /* Special pictures IDs */
      let specialPictureIds = this.ProfileDocument.special_pictures &&
        Object.keys(this.ProfileDocument.special_pictures).length
          ? Object.keys(this.ProfileDocument.special_pictures)
              .filter(
                x =>
                  this.ProfileDocument.special_pictures[x] &&
                  this.ProfileDocument.special_pictures[x].photo &&
                  this.ProfileDocument.special_pictures[x].photo.id
              )
              .map(x => this.ProfileDocument.special_pictures[x].photo.id)
          : [];
      assignedPhotoIds = assignedPhotoIds.concat(specialPictureIds);
      
      for (let i = 0; i < this.albumList.length; i++) {
        let album = this.albumList[i];
        if (
          album &&
          album.photo &&
          album.photo.length
        ) {

          assignedPhotoIds = assignedPhotoIds.concat(Array.from(
            this.ProfileDocument.chapters.filter(c => c.items && c.items.length),
            chapter =>
              chapter.items
                .filter(i => i.photo && i.photo.id)
                .map(item => item.photo.id)
            )
            .join()
            .split(",")
          );
          
          this.unassignedItems = this.unassignedItems.concat(album.photo
            .filter(photo => assignedPhotoIds.indexOf(photo.photo.id) === -1)
            .map(photo => {
              return {
                photo: {
                  filename: photo.photo.filename,
                  mimetype: photo.photo.mimetype,
                  size: photo.photo.size,
                  thumb_url: photo.photo.thumb_url,
                  webview_url: photo.photo.webview_url,
                  original_url: photo.photo.original_url,
                  caption: photo.photo.caption,
                  id: photo.photo.id
                },
                type: "Photo",
                _id: photo._id
              };
            })
          );
        }
      }
    },
    isAlreadyAssigned(photo) {
      if (
        photo &&
        this.unassignedItems &&
        this.unassignedItems.length
      ) {
        let index = this.unassignedItems.findIndex(x => x.photo.id.toString() === photo.photo.id.toString());
        return index === -1;
      }
      return false;
    },
    isLowQualityImage(photo) {
      return (
        photo &&
        photo.photo &&
        photo.photo.size &&
        photo.photo.size <= config.imageQuality
      );
    },

    async submitContent() {
      swal
        .fire({
          title: "Are you sure?",
          text: "Have you finished adding the content for this chapter?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, submit it!"
        })
        .then(async result => {
          if (result.value) {
            if (this.currentDocument) {
              /* Set the content if not yet clicked on save button */
              if (this.enableContentSave) {
                this.setNewContent();
              }
              /* Check if all ready for review */
              if (!(await this.validateData("content"))) {
                swal.fire({
                  type: "warning",
                  title: "Incomplete",
                  text: "Please make sure you added the chapter content",
                  timer: 2500,
                  onClose: () => {
                    return;
                  }
                });
                return;
              }

              /* Make all the status into Review if not yet Approved */
              if (this.currentDocument.content.status !== "Approved") {
                this.currentDocument.content.status = "Suggestion";
                this.currentDocument.content.status_date = new Date().toISOString();
              }

              this.ProfileDocument.chapters[
                this.currentDocumentIndex
              ] = this.currentDocument;
              this.ProfileDocument = this.ProfileDocument;

              await this.updateProfileDocument("submitContent");

              this.isContentSubmitted = true;

              /* Create the message */
              this.message.content = '<v-layout>';
              this.message.content += `<p>Your writer revised your content and suggested an update for the chapter "${this.currentDocument.name}". You can either revise or approve the suggestion.</p>`;
              this.message.content += `<p><span class="pf-bg-white pa-2 border-radius-10 elevation-1 pf-font-12 ${ this.statusTexts['Suggestion'].class }"><i aria-hidden="true" class="mr-1 v-icon material-icons theme--light ${ this.statusTexts['Suggestion'].class }" style="font-size: 16px;">${ this.statusTexts['Suggestion'].icon }</i>${ this.statusTexts['Suggestion'].text }</span></p>`;
              this.message.content += `</v-layout>`;
              await this.send(true);

            }
          }
        });
    },

    async validateData(type) {
      let isReady = true;
      let doc = this.currentDocument;

      if (type === "content") {
        let content =
          doc.content &&
          doc.content.revision &&
          doc.content.revision.length &&
          doc.content.revision[doc.content.revision.length - 1].text
            ? doc.content.revision[doc.content.revision.length - 1].text
            : null;

        if (
          !content ||
          !content.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length
        ) {
          isReady = false;
        }
      } else if (type === "photos") {
        if (!doc.items || !doc.items.length) {
          isReady = false;
        }
      }
      return isReady;
    },

    updateContentStatus(status) {
      if (!status || !this.currentDocument) {
        return;
      }
      let text = 'Approved' === status ? 'approve' : 'add suggestion on';
      swal
        .fire({
          title: "Sure?",
          text: `Are you sure to ${text} the content ?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, go ahead!"
        })
        .then(async result => {
          if (result.value) {
            /* Enable the loading screen */
            window.getApp.$emit('BGProgress', false);
            
            /* change the status and update the document */
            this.currentDocument.content.status = status;
            this.currentDocument.content.status_date = new Date().toISOString();

            this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
            this.ProfileDocument = this.ProfileDocument;

            await this.updateProfileDocument(
            "contentStatus",
            status,
            null
            );

            /* Create the message */
            this.message.content = '<v-layout>';
            if (status === 'Approved') {
              this.message.content += `<p>The content for the chapter "${this.currentDocument.name}" has been approved by the writer</p>`;
            } else if (status === 'AgencySuggestion') {
            this.message.content += `<p>The agency updated the content for the chapter "${this.currentDocument.name}". You can approve it or add suggestions.</p>`;
            }
            this.message.content += `<p><span class="pf-bg-white pa-2 border-radius-10 elevation-1 pf-font-12 ${ this.statusTexts[status].class }"><i aria-hidden="true" class="mr-1 v-icon material-icons theme--light ${ this.statusTexts[status].class }" style="font-size: 16px;">${ this.statusTexts[status].icon }</i>${ this.statusTexts[status].text }</span></p>`;
            this.message.content += `</v-layout>`;

            await this.send(true);

            /* Disable the loading screen */
            window.getApp.$emit('BGProgress', true);
          }
        });
    },
    updatePDFStatus(status) {
      if (!status || !this.ProfileDocument || !this.ProfileDocument.pdf) {
        return;
      }
      let text = status === 'ParentReview' ? 'approve' : 'add suggestions on';
      swal
        .fire({
          title: "Sure?",
          text: `Are you sure to ${text} the profile book?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, go ahead!"
        })
        .then(async result => {
          if (result.value) {
            window.getApp.$emit('BGProgress', false);
            let suggestionText = null;
            if (status === "Need Attention") {
              const { value: suggestion } = await swal.fire({
                title: "Please add your suggestion",
                input: "textarea",
                inputValue: "",
                inputPlaceholder: "Type your suggestion here...",
                showCancelButton: true,
                inputValidator: value => {
                  if (!value) {
                    return "You need to enter the suggestion";
                  }
                }
              });
              if (suggestion && suggestion.trim()) {
                suggestionText = suggestion;
              }
            }

            if (
              status !== "Need Attention" ||
              (suggestionText && suggestionText.trim())
            ) {
              /* change the status and update the document */
              if (!this.ProfileDocument.pdf.review_history) {
                this.ProfileDocument.pdf.review_history = [];
              }
              let newStatus = {
                status: status,
                status_date: new Date().toISOString()
              };
              if (suggestionText) {
                newStatus.description = suggestionText;
              }
              this.ProfileDocument.pdf.review_history.push(newStatus);
              
              this.ProfileDocument.request_from = 'pdfStatusWriter';
              this.ProfileDocument = this.ProfileDocument;

              await this.updateProfileDocument(
                "pdfStatusWriter",
                status,
                suggestionText
              );
            }
            window.getApp.$emit('BGProgress', true);
          }
        });
    },
    async updateCoverPhotoStatus (status) {
      /* Change the status of the selected photos */
      if (this.currentCoverPhoto && this.coverPhotoType && this.ProfileDocument.special_pictures[this.coverPhotoType]) {
        let text = status === 'Approved' ? 'approve' : 'add suggestion on';
        swal.fire({
          title: "Sure?",
          text: `Are you sure to ${text} the ${this.coverPhotoType.replace('_', ' ')} ?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, go ahead!"
        })
        .then(async result => {
          if (result.value) {
            
            /* Enable the loading screen */
            window.getApp.$emit('BGProgress', false);

            let suggestionText = null;
            if (status === 'AgencyReplace') {
              const { value: suggestion } = await swal.fire({
                title: "Please type the reason",
                input: "textarea",
                inputValue: "",
                inputPlaceholder: "Type your text here...",
                showCancelButton: true,
                inputValidator: value => {
                  if (!value) {
                    return "You need to enter the reason";
                  }
                }
              });
              if (suggestion && suggestion.trim()) {
                suggestionText = suggestion;
              }
            }

            if (['AgencyReplace'].indexOf(status) === -1 || (suggestionText && suggestionText.trim())) {
              
              this.ProfileDocument.special_pictures[this.coverPhotoType].status = status;
              let statusDate = (new Date()).toISOString();
              this.ProfileDocument.special_pictures[this.coverPhotoType].status_date = statusDate;
              this.ProfileDocument.special_pictures[this.coverPhotoType].agency = this.Agency.id;

              if (suggestionText) {
                this.ProfileDocument.special_pictures[this.coverPhotoType].description = suggestionText;
              }

              this.ProfileDocument = this.ProfileDocument;
      
              let { error, data } = await this.updateProfileDocument("coverStatus", status, suggestionText);
              if (!error) {
                this.currentCoverPhoto.status = status;
                this.currentCoverPhoto.status_date = statusDate;
                this.currentCoverPhoto.agency = this.Agency.id;
                
                /* Create the message */
                this.message.content = '<v-layout>';
                if (status === 'AgencyReplace') {
                  this.message.content += `<p>Your agency asked you to replace the ${this.coverPhotoType.replace('_', ' ')} photo</p>`;

                  if (suggestionText) {
                    this.message.content += `<p>Reason: ${ suggestionText }</p>`;
                  }
                } else if (status === 'Approved') {
                  this.message.content += `<p>Your ${this.coverPhotoType.replace('_', ' ')} photo has been approved by the agency.</p>`;
                }
                this.message.content += `<p><span class="pf-bg-white pa-2 border-radius-10 elevation-1 pf-font-12 ${ this.statusTexts[status].class }"><i aria-hidden="true" class="mr-1 v-icon material-icons theme--light ${ this.statusTexts[status].class }" style="font-size: 16px;">${ this.statusTexts[status].icon }</i>${ this.statusTexts[status].text }</span></p>`;
                this.message.content += `<img width="100%" src="${this.getCoverImage(this.currentCoverPhoto.photo)}"/>`;
                this.message.content += `</v-layout>`;
                await this.send(true);

                /* Close the large photo view */
                this.closeViewCoverPhoto();

              }
            }
            /* Disable the loading screen */
            window.getApp.$emit('BGProgress', true);
          }
        });
      }
    },

    async updatePhotoStatus(status) {
      /* Change the status of the selected photos */
      if (this.currentPhoto && this.currentPhotoIndex > -1) {
        let text = status === 'Approved' ? 'approve the photo' : 'add suggestion on the photo';
        swal.fire({
          title: "Sure?",
          text: `Are you sure to ${text} ?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, go ahead!"
        })
        .then(async result => {
          if (result.value) {

            /* Enable the loading screen */
            window.getApp.$emit('BGProgress', false);

            let suggestionText = null;
            if (status === 'AgencyReplace') {
              const { value: suggestion } = await swal.fire({
                title: "Please type the reason",
                input: "textarea",
                inputValue: "",
                inputPlaceholder: "Type your text here...",
                showCancelButton: true,
                inputValidator: value => {
                  if (!value) {
                    return "You need to enter the reason";
                  }
                }
              });
              if (suggestion && suggestion.trim()) {
                suggestionText = suggestion;
              }
            }

            if (['AgencyReplace'].indexOf(status) === -1 || (suggestionText && suggestionText.trim())) {
              
              let statusDate = (new Date()).toISOString();
              this.currentDocument.items[this.currentPhotoIndex].status = status;
              this.currentDocument.items[this.currentPhotoIndex].status_date = statusDate;
              this.currentDocument.items[this.currentPhotoIndex].agency = this.Agency.id;

              if (suggestionText) {
                this.currentDocument.items[this.currentPhotoIndex].description = suggestionText;
              }

              this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
              this.ProfileDocument = this.ProfileDocument;
      
              let { error, data } = await this.updateProfileDocument("photosStatus", status, suggestionText);
              if (!error) {
                if (this.currentPhoto) {
                  this.currentPhoto.status = status;
                  this.currentPhoto.status_date = statusDate;
                  this.currentPhoto.agency = this.Agency.id;
                }
                
                /* Create the message */
                this.message.content = '<v-layout>';

                if (status === 'AgencyReplace') {
                  this.message.content += `<p>Your agency asked you to replace the photo.</p>`;

                  if (suggestionText) {
                    this.message.content += `<p>Reason: ${ suggestionText }</p>`;
                  }

                } else if (status === 'Approved') {
                  this.message.content += `<p>Your photo has been approved by the agency.</p>`;
                }
                
                this.message.content += `<p><span class="pf-bg-white pa-2 border-radius-10 elevation-1 pf-font-12 ${ this.statusTexts[this.currentPhoto.status].class }"><i aria-hidden="true" class="mr-1 v-icon material-icons theme--light ${ this.statusTexts[this.currentPhoto.status].class }" style="font-size: 16px;">${ this.statusTexts[this.currentPhoto.status].icon }</i>${ this.statusTexts[this.currentPhoto.status].text }</span></p>`;
                this.message.content += `<img width="100%" src="${this.currentPhoto.photo.thumb_url}"/>`;

                this.message.content += `</v-layout>`;

                await this.send(true);

                /* Close the large photo view */
                this.closeViewPhoto();
              }
            }
            /* Disable the loading screen */
            window.getApp.$emit('BGProgress', true);
          }
        });
      }
    },
    editContent () {
      if (this.currentDocument && this.currentDocument.content && this.currentDocument.content.revision && this.currentDocument.content.revision.length) {
        /* Close the split screen */
        this.splitContentRevision = false;
        let revLength = this.currentDocument.content.revision.length;
        this.currentDocument.content.revision.push({
          text: this.currentDocument.content.revision[revLength - 1].text, owner: 'Agency',
          date: (new Date()).toISOString(),
        });
        this.currentDocument.content.status = 'AgencySuggestion';
        this.currentDocument.content.status_date = (new Date()).toISOString();
        this.currentDocument.content.agency = this.Agency.id;
      }
      /* Switch to the new tab */
      this.contentsModel = `tab-${this.currentDocument.content.revision.length}`;
    },

    addCallout () {
      if (this.newCallout && this.newCallout.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
        if (!this.currentDocument.callouts) {
          this.currentDocument.callouts = [];
        }
        this.currentDocument.callouts.push(this.newCallout);
        this.newCallout = '';
        /* Update the document */
        this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
        this.ProfileDocument = this.ProfileDocument;
        this.updateProfileDocument('callout');
      }
    },
    addNote () {
      if (this.newNote && this.newNote.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
        if (!this.currentDocument.notes) {
          this.currentDocument.notes = [];
        }
        this.currentDocument.notes.push(this.newNote);
        this.newNote = '';
        /* Update the document */
        this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
        this.ProfileDocument = this.ProfileDocument;
        this.updateProfileDocument('note');
      }
    },
    submitFinalDocument () {
      swal
        .fire({
          title: "Are you sure?",
          text: "Are you sure you want to submit the profile document? It'll take a bit time based on the document size",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, continue!"
        })
        .then(async result => {
          if (result.value) {
            
            /* Enable the loading screen - it takes time */
            window.getApp.$emit('BGProgress', false);

            let payload = {
              profile_document: this.ProfileDocument.id
            };
            let { error, data } = await request('ProfileDocument/Archive', 'POST', payload);
            if (error) {
              console.log(error);
              swal.fire({
                type: 'warning',
                title: 'Error',
                text: `${error.message || error}, please try again. If problem persists please contact technical team`,
                showConfirmButton: true,
              });
            } else {
              if (data && data.submitted && data.zip) {
                this.ProfileDocument.submitted = data.submitted;
                this.ProfileDocument.zip = data.zip;
                this.ProfileDocument.submitted_date = data.submitted_date;
                this.ProfileDocument = this.ProfileDocument;
                swal.fire({
                  type: "success",
                  title: "Success",
                  text: `The profile document was successfully submitted`,
                  timer: 2500,
                });
              }
            }
            /* Disable the loading screen */
            window.getApp.$emit('BGProgress', true);
          }
        })
    },
    // getFlipbookFirstPage () {
    //   let firstPage = null;
    //   if (this.templateItems) {
    //     let index = this.templateItems.findIndex(x => x.name === this.design.template);
    //     if (index > -1) {
    //       firstPage = this.templateItems[index].file.substring(this.templateItems[index].file.lastIndexOf('/'), -1) + '/files/picon/1.jpeg';
    //     }
    //   }
    //   return firstPage;
    // },
    // viewFlipbook () {
    //   if (this.currentTemplate) {
    //     this.flipbookViewModal = true;
    //   }
    // },
    // closeFlipbookView () {
    //   this.currentTemplate = null;
    //   this.currentTemplateIndex = -1;
    //   this.flipbookViewModal = false;
    // },
    viewAlbum (album, index) {
      this.currentAlbum = album;
      this.currentAlbumIndex = index;
    },
    backFromPhotos () {
      this.currentAlbum = null;
      this.currentAlbumIndex = -1;
    },
    showCommentsTips (type) {
      /* Hide the Split screen */
      if (this.splitContentRevision) {
        this.splitContentRevision = !this.splitContentRevision;
      }
      if (type === 'comments') {
        this.tipsTabs = 'tab-1';
        this.showTips = false;
        this.showComments = !this.showComments;
      } else {
        this.tipsTabs = 'tab-2';
        this.showComments = false;
        this.showTips = !this.showTips;
      }
      /* Trigger window resize to re-arrange the photos */
      window.dispatchEvent(new Event('resize'));
    },
    closeCommentsTips() {
      this.showComments = this.showTips = false;
      /* Trigger window resize to re-arrange the photos */
      window.dispatchEvent(new Event('resize'));
    },
    toggleSplitScreen () {
      /* Hide the comments and tips box */
      if (this.showComments || this.showTips) {
        this.showTips = this.showComments = false;
      }
      this.splitContentRevision = !this.splitContentRevision;
    },
    chapterSliderChanged (photoIndex, index) {
      if (photoIndex > -1 && index > -1) {
        this.chapterPhotoSlides[index] = photoIndex;
        this.chapterPhotoSlides = this.chapterPhotoSlides;
      }
    },
    currentChapterPhoto (index) {
      if (typeof this.chapterPhotoSlides[index] !== 'undefined') {
        return this.chapterPhotoSlides[index] + 1;
      }
      return 1;
    },
    setGroupedChapterPhotos (toReturn = false) {
      let datedPhotos = {};
      this.currentDocument.items.forEach(item => {
        if (item.submitted_date) {
          let date = item.submitted_date.substr(0, 10);
          if (!datedPhotos[date]) {
            datedPhotos[date] = [];
          }
          datedPhotos[date].push(item);
        } else {
          if (!datedPhotos['N/A']) {
            datedPhotos['N/A'] = [];
          }
          datedPhotos['N/A'].push(item);
        }
      });
      if (toReturn) {
        return datedPhotos;
      } else {
        this.groupedChapterPhotos = datedPhotos;
      }
    },
    mainTabsChange (tabId) {
      if (tabId && tabId === 'tab-3') {
        /* Set the currentTipsText */
        if (this.profileSettings.tips_text && this.profileSettings.tips_text.covers_spread) {
          this.currentTipsText = this.profileSettings.tips_text.covers_spread;
        }
        /* Load the cover conversation */
        this.loadConversation(true);
      }
    },
    chapterTabsChange (tabId) {
      this.showComments = this.showTips = false;
      if (tabId && tabId === 'tab-2') {
        /* Set to add photo if no items available */
        if (this.currentDocument && (!this.currentDocument.items || !this.currentDocument.items.length)) {
          this.selectPhotos();
        }
      }
    },
    removeSpecialPicture (photo) {

      swal.fire({
        title: 'Are you sure?',
        text: `Do you want to remove the ${photo.name} ?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove it!'
      }).then(async (result) => {
        if (result.value) {
          (async () => {
            if (this.ProfileDocument.special_pictures[photo.key] && this.ProfileDocument.special_pictures[photo.key].status !== 'Approved') {
              this.ProfileDocument.special_pictures[photo.key] = {
                status: 'Pending',
                status_date: (new Date()).toISOString()
              };
              this[photo.key] = null;
              await this.updateProfileDocument();
            }
          })();
        }
      });

    }
  }
};
</script>

<style scoped>
.playbackButton {
  top: calc(50% - 19px);
  left: calc(50% - 19px);
}
.v-menu__content {
  margin-top: 28px;
}
.image_class {
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 120px;
  width: 100%;
}
.special_image {
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* height: 209px; */
  width: 100%;
}
.thumb_image {
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 35px;
  width: 100%;
}
.text-truncate {
  line-height: inherit !important;
}
.image-view {
  width: 100%;
}
.new-message-section {
  position: relative;
  bottom: 50px;
  border-top: 1px solid #ccc;
}
.section-tab-counter {
  padding: 2px 7px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProfileDocuments/agency_view.vue